
export const questionBank = [
    // C# Fundamentals
    {
        id: 1,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is the difference between "String" and "string" in C#?',
        options: [
            '"String" is a reference type while "string" is a value type stored on the stack',
            '"String" is a class, "string" is a keyword alias for System.String',
            '"string" is used for mutable strings while "String" is for immutable strings',
            '"String" is deprecated and should be replaced with "string" in modern C#'
        ],
        correct: 1,
        explanation: '"string" is a C# keyword that is an alias for System.String class. Both refer to the same type, but "string" is preferred for variable declarations.'
    },
    {
        id: 2,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is boxing and unboxing in C#?',
        options: [
            'The process of compressing data to save memory usage in large collections',
            'Converting value types to reference types and vice versa',
            'Encapsulating private fields within public properties to ensure data integrity',
            'Creating sealed classes that cannot be inherited by other classes'
        ],
        correct: 1,
        explanation: 'Boxing converts a value type to an object reference type. Unboxing extracts the value type from the object. This can impact performance.'
    },
    {
        id: 3,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'What is the purpose of the "volatile" keyword in C#?',
        options: [
            'To prevent a variable from being modified by external assemblies',
            'To indicate that a field might be modified by multiple threads',
            'To ensure a variable is stored in the CPU cache for faster access',
            'To mark a variable as read-only after initialization'
        ],
        correct: 1,
        explanation: 'The volatile keyword indicates that a field can be modified by multiple threads. It prevents compiler optimizations that assume single-threaded execution.'
    },

    // ASP.NET Core
    {
        id: 4,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'What is middleware in ASP.NET Core?',
        options: [
            'A database connection layer ensuring data integrity',
            'Software that handles requests and responses in the pipeline',
            'A caching mechanism used to store static assets',
            'A routing engine that maps URLs to controllers'
        ],
        correct: 1,
        explanation: 'Middleware is software assembled into an application pipeline to handle requests and responses. Each component can perform operations before and after the next component.'
    },
    {
        id: 5,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is the difference between AddScoped, AddTransient, and AddSingleton in Dependency Injection?',
        options: [
            'They define the security level of the injected service',
            'Different lifetimes: per request, per use, and application lifetime',
            'Different ways to register interfaces in the global configuration',
            'Different thread safety levels determined by the CLR'
        ],
        correct: 1,
        explanation: 'AddScoped creates one instance per request, AddTransient creates a new instance every time, and AddSingleton creates one instance for the application lifetime.'
    },
    {
        id: 6,
        category: 'ASP.NET Core',
        difficulty: 'Hard',
        question: 'What is the purpose of IHostedService in ASP.NET Core?',
        options: [
            'To host web APIs within a Windows Service',
            'To run background tasks in the application',
            'To manage database connections in a clustered environment',
            'To handle authentication logic for third-party providers'
        ],
        correct: 1,
        explanation: 'IHostedService allows you to run background tasks in ASP.NET Core applications. Useful for scheduled jobs, message processing, and long-running operations.'
    },

    // Entity Framework
    {
        id: 7,
        category: 'Entity Framework',
        difficulty: 'Easy',
        question: 'What is Entity Framework Core?',
        options: [
            'A JavaScript framework for building frontend applications',
            'An ORM (Object-Relational Mapper) for .NET',
            'A unit testing framework for verifying database logic',
            'A user interface library for desktop applications'
        ],
        correct: 1,
        explanation: 'Entity Framework Core is a lightweight, extensible ORM that enables .NET developers to work with databases using .NET objects.'
    },
    {
        id: 8,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is the difference between eager loading, lazy loading, and explicit loading?',
        options: [
            'Different database engines supported by EF Core',
            'Different ways to load related entities',
            'Different caching strategies for query performance',
            'Different connection methods for SQL Server'
        ],
        correct: 1,
        explanation: 'Eager loading loads related data upfront with Include(). Lazy loading loads data on access. Explicit loading loads related data on demand using Load().'
    },
    {
        id: 9,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What is the N+1 query problem in Entity Framework?',
        options: [
            'A database connection error caused by too many open connections',
            'When one query loads parent entities and N queries load related entities',
            'A query optimization technique for reducing server load',
            'A caching issue where N items are cached for every 1 request'
        ],
        correct: 1,
        explanation: 'N+1 occurs when you load a collection and then iterate it, causing one query for the collection plus N queries for each item\'s related data. Use eager loading to fix.'
    },

    // LINQ
    {
        id: 10,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What does LINQ stand for?',
        options: [
            'Linear Integrated Query Language',
            'Language Integrated Query',
            'Linked Query Processing System',
            'List Query and Enumeration'
        ],
        correct: 1,
        explanation: 'LINQ stands for Language Integrated Query. It allows writing queries directly in C# with compile-time checking and IntelliSense support.'
    },
    {
        id: 11,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is the difference between First() and FirstOrDefault()?',
        options: [
            'First() returns the first item or null, FirstOrDefault() throws exception',
            'First() throws exception if empty, FirstOrDefault() returns default value',
            'FirstOrDefault() is significantly faster for large collections',
            'First() returns multiple values if duplicates exist'
        ],
        correct: 1,
        explanation: 'First() throws an InvalidOperationException if the sequence is empty, while FirstOrDefault() returns the default value (null for reference types, 0 for numbers).'
    },
    {
        id: 12,
        category: 'LINQ',
        difficulty: 'Hard',
        question: 'What is deferred execution in LINQ?',
        options: [
            'A performance issue where queries run slower than expected',
            'Query execution is delayed until iteration',
            'Queries that run in a background thread automatically',
            'Queries that are compiled into stored procedures'
        ],
        correct: 1,
        explanation: 'Deferred execution means LINQ queries are not executed when defined, but when enumerated (e.g., in a foreach loop or calling ToList()). This allows query composition.'
    },

    // Design Patterns
    {
        id: 13,
        category: 'Design Patterns',
        difficulty: 'Easy',
        question: 'What is the Singleton pattern?',
        options: [
            'A pattern that allows multiple instances of a class to share state',
            'Ensures a class has only one instance',
            'A database pattern for managing single-row tables',
            'A UI pattern for single-page applications'
        ],
        correct: 1,
        explanation: 'Singleton pattern ensures a class has only one instance and provides a global point of access to it. Commonly used for logging, configuration, and caching.'
    },
    {
        id: 14,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Repository pattern used for?',
        options: [
            'Managing file storage and retrieval optimization',
            'Abstracting data access logic',
            'Organizing UI components in a modular way',
            'Implementing complex security protocols'
        ],
        correct: 1,
        explanation: 'Repository pattern abstracts data access logic, providing a collection-like interface for accessing domain objects. Separates business logic from data access.'
    },
    {
        id: 15,
        category: 'Design Patterns',
        difficulty: 'Hard',
        question: 'What is CQRS (Command Query Responsibility Segregation)?',
        options: [
            'A specific type of NoSQL database architecture',
            'Separating read and write operations into different models',
            'A caching strategy for high-performance applications',
            'An authentication pattern for microservices'
        ],
        correct: 1,
        explanation: 'CQRS separates read (query) and write (command) operations, allowing independent optimization, scaling, and modeling of each side. Useful for complex domains.'
    },

    // Threading & Async
    {
        id: 16,
        category: 'Threading & Async',
        difficulty: 'Easy',
        question: 'What is the difference between synchronous and asynchronous programming?',
        options: [
            'Synchronous runs on the server, asynchronous runs on the client',
            'Synchronous blocks until complete, asynchronous allows other work while waiting',
            'Asynchronous is always faster regardless of the operation type',
            'Synchronous uses multiple threads to speed up processing'
        ],
        correct: 1,
        explanation: 'Synchronous execution blocks and waits for operations to complete. Asynchronous execution allows the program to continue while waiting, improving responsiveness.'
    },
    {
        id: 17,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is the purpose of async/await keywords?',
        options: [
            'To explicitly create and manage new background threads',
            'To write asynchronous code that looks synchronous',
            'To optimize memory usage usage during garbage collection',
            'To handle global application exceptions automatically'
        ],
        correct: 1,
        explanation: 'async/await allows writing asynchronous code in a synchronous-looking style, making it easier to read and maintain while preserving asynchronous benefits.'
    },
    {
        id: 18,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is a deadlock and how can it occur?',
        options: [
            'A performance optimization that stops unused threads',
            'When two or more threads wait for each other indefinitely',
            'A database connection issue caused by high latency',
            'A memory leak resulting from unmanaged resources'
        ],
        correct: 1,
        explanation: 'A deadlock occurs when two or more threads are blocked forever, each waiting for the other to release a resource. Prevent with proper lock ordering and timeouts.'
    },

    // Security
    {
        id: 19,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is the difference between authentication and authorization?',
        options: [
            'There is no difference between them as they are typically handled by the same identity provider',
            'Authentication verifies identity, authorization determines permissions',
            'Authorization verifies identity, authentication determines permissions',
            'Both processes verify the identity of the user but at different stages of the request pipeline'
        ],
        correct: 1,
        explanation: 'Authentication verifies who you are (login). Authorization determines what you can access (permissions). Authentication comes before authorization.'
    },
    {
        id: 20,
        category: 'Security',
        difficulty: 'Hard',
        question: 'What is JWT (JSON Web Token) and how is it used?',
        options: [
            'A binary database format optimized for storing user credentials securely',
            'A compact token format for securely transmitting claims',
            'A proprietary JavaScript framework used for managing session state in SPAs',
            'An encryption algorithm used to hash passwords before storing them in the database'
        ],
        correct: 1,
        explanation: 'JWT is a compact, URL-safe token containing JSON claims. Used for authentication and information exchange. Contains header, payload, and signature sections.'
    },

    // More C# Fundamentals
    {
        id: 21,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is the difference between "==" and "Equals()" in C#?',
        options: [
            'They are identical and can be used interchangeably for all types',
            '"==" typically compares references, Equals() can be overridden for value comparison',
            'Equals() is deprecated and should be avoided in favor of the "==" operator',
            '"==" is significantly slower than Equals() and should be used only for primitives'
        ],
        correct: 1,
        explanation: '"==" typically compares references for reference types, while Equals() can be overridden to compare values. For value types, both compare values by default.'
    },
    {
        id: 22,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is the purpose of the "sealed" keyword?',
        options: [
            'To prevent a class from being inherited or a method from being overridden',
            'To make all variables within a class constant and immutable',
            'To create static classes that cannot be instantiated',
            'To improve performance by forcing the compiler to inline methods'
        ],
        correct: 0,
        explanation: 'The sealed keyword prevents inheritance when applied to a class, or prevents further overriding when applied to a virtual method.'
    },
    {
        id: 23,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What are Value Types and Reference Types in C#?',
        options: [
            'Different naming conventions for variables based on their scope',
            'Value types store data directly, reference types store memory addresses',
            'Value types are slower to access but use less memory than reference types',
            'Reference types use less memory but are slower to access than value types'
        ],
        correct: 1,
        explanation: 'Value types (int, struct, enum) store actual data on the stack. Reference types (class, interface, delegate) store references to data on the heap.'
    },
    {
        id: 24,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'What is the difference between IEnumerable and IQueryable?',
        options: [
            'No difference, they are aliases for the same underlying interface',
            'IQueryable supports deferred execution and can be translated to SQL',
            'IEnumerable is significantly faster for database operations',
            'IQueryable is deprecated and replaced by IEnumerable in .NET Core'
        ],
        correct: 1,
        explanation: 'IQueryable extends IEnumerable and allows LINQ queries to be translated to other query languages (like SQL). IEnumerable executes queries in-memory.'
    },
    {
        id: 25,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is the "using" statement used for?',
        options: [
            'Only for importing namespaces at the beginning of a file',
            'For both importing namespaces and automatic resource disposal',
            'For creating temporary variables that exist only within a specific block',
            'For handling exceptions that occur during file I/O operations'
        ],
        correct: 1,
        explanation: 'The using statement has two purposes: importing namespaces and ensuring IDisposable objects are properly disposed, even if exceptions occur.'
    },

    // More ASP.NET Core
    {
        id: 26,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'What is the purpose of appsettings.json?',
        options: [
            'To store application configuration',
            'To store user data',
            'To cache responses',
            'To log errors'
        ],
        correct: 0,
        explanation: 'appsettings.json stores application configuration like connection strings, API keys, and environment-specific settings in a structured JSON format.'
    },
    {
        id: 27,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is the difference between IActionResult and ActionResult<T>?',
        options: [
            'There is no functional difference between them',
            'ActionResult<T> provides type safety and better documentation',
            'IActionResult is faster because it does not require generic type resolution',
            'ActionResult<T> is deprecated in favor of simple object return types'
        ],
        correct: 1,
        explanation: 'ActionResult<T> combines the flexibility of IActionResult with type safety. It clearly documents the expected return type and enables better OpenAPI documentation.'
    },
    {
        id: 28,
        category: 'ASP.NET Core',
        difficulty: 'Hard',
        question: 'What is the purpose of Model Binding in ASP.NET Core?',
        options: [
            'To connect the application to external databases using Entity Framework',
            'To automatically map HTTP request data to action method parameters',
            'To validate user input against a set of predefined security rules',
            'To serialize complex C# objects into JSON format for API responses'
        ],
        correct: 1,
        explanation: 'Model Binding automatically maps data from HTTP requests (query strings, route data, form fields, JSON) to action method parameters.'
    },
    {
        id: 29,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What are Action Filters in ASP.NET Core?',
        options: [
            'SQL queries used to filter data retrieved from the database',
            'Attributes that run code before/after controller actions',
            'Security features that prevent unauthorized access to static files',
            'Routing mechanisms that direct traffic to specific controllers'
        ],
        correct: 1,
        explanation: 'Action Filters are attributes that allow you to run code before or after specific stages in the request processing pipeline, like authorization or caching.'
    },
    {
        id: 30,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'What is the purpose of CORS in ASP.NET Core?',
        options: [
            'To optimize API performance by compressing responses',
            'To allow cross-origin resource sharing from browsers',
            'To encrypt data transmitted between client and server',
            'To cache static assets on the client side'
        ],
        correct: 1,
        explanation: 'CORS (Cross-Origin Resource Sharing) allows your API to be accessed from web pages served from different domains, which browsers block by default for security.'
    },

    // More Entity Framework
    {
        id: 31,
        category: 'Entity Framework',
        difficulty: 'Easy',
        question: 'What is a DbContext in Entity Framework?',
        options: [
            'A single database table representation',
            'A class representing a session with the database',
            'A connection string configuration object',
            'A tool for building complex SQL queries'
        ],
        correct: 1,
        explanation: 'DbContext represents a session with the database, allowing you to query and save data. It manages entity objects during runtime and tracks changes.'
    },
    {
        id: 32,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is the difference between Add() and Attach() methods?',
        options: [
            'They are aliases for the same operation',
            'Add() marks entity as Added, Attach() marks as Unchanged',
            'Attach() is deprecated in EF Core',
            'Add() performs an immediate database insert, while Attach() is delayed'
        ],
        correct: 1,
        explanation: 'Add() marks the entity as Added (will be inserted). Attach() marks it as Unchanged (exists in DB). Use Add for new entities, Attach for existing ones.'
    },
    {
        id: 33,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What are Shadow Properties in EF Core?',
        options: [
            'Columns in the database that are hidden from the user',
            'Properties that exist in the model but not in the entity class',
            'Properties that are encrypted at rest',
            'Deprecated properties from previous EF versions'
        ],
        correct: 1,
        explanation: 'Shadow properties exist in the EF Core model but not in the .NET entity class. Useful for audit fields like CreatedDate without cluttering entity classes.'
    },
    {
        id: 34,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is the purpose of AsNoTracking() in EF Core?',
        options: [
            'To permanently delete records from the database',
            'To disable change tracking for read-only queries',
            'To encrypt queries sent to the database',
            'To cache query results in memory'
        ],
        correct: 1,
        explanation: 'AsNoTracking() disables change tracking, improving performance for read-only queries where you don\'t need to update the data.'
    },
    {
        id: 35,
        category: 'Entity Framework',
        difficulty: 'Easy',
        question: 'What is a Migration in EF Core?',
        options: [
            'A complete backup of the database',
            'A way to version control database schema changes',
            'A query optimization technique',
            'A strategy for caching frequent queries'
        ],
        correct: 1,
        explanation: 'Migrations allow you to incrementally update the database schema in sync with your model changes, while preserving existing data.'
    },

    // More LINQ
    {
        id: 36,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What does the "Where" clause do in LINQ?',
        options: [
            'Sorts the data in ascending order',
            'Filters data based on a condition',
            'Groups data by a specified key',
            'Joins two tables based on a common column'
        ],
        correct: 1,
        explanation: 'The Where clause filters a sequence of values based on a predicate (condition). It returns only elements that satisfy the condition.'
    },
    {
        id: 37,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is the difference between Select and SelectMany?',
        options: [
            'There is no functional difference',
            'SelectMany flattens nested collections into a single sequence',
            'Select is significantly faster than SelectMany',
            'SelectMany is deprecated'
        ],
        correct: 1,
        explanation: 'Select projects each element to a new form. SelectMany projects each element to a collection and flattens the results into one sequence.'
    },
    {
        id: 38,
        category: 'LINQ',
        difficulty: 'Hard',
        question: 'What is the difference between IEnumerable<T> and ICollection<T>?',
        options: [
            'They are identical interfaces',
            'ICollection<T> adds Count and modification methods',
            'IEnumerable is faster for all operations',
            'ICollection is a deprecated interface'
        ],
        correct: 1,
        explanation: 'ICollection<T> extends IEnumerable<T> and adds Count property, Add(), Remove(), Clear() methods. It represents a modifiable collection.'
    },
    {
        id: 39,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is the purpose of the "Any()" method?',
        options: [
            'To count the total number of elements',
            'To check if any element matches a condition',
            'To sort elements randomly',
            'To group elements by a predicate'
        ],
        correct: 1,
        explanation: 'Any() determines whether any element in a sequence satisfies a condition. It returns true if at least one element matches, false otherwise.'
    },
    {
        id: 40,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What does the "OrderBy" method do?',
        options: [
            'Filters data based on a condition',
            'Sorts elements in ascending order',
            'Groups data by a key',
            'Removes duplicate elements'
        ],
        correct: 1,
        explanation: 'OrderBy sorts elements in ascending order based on a key. Use OrderByDescending for descending order. Can chain with ThenBy for multiple sort keys.'
    },

    // More Design Patterns
    {
        id: 41,
        category: 'Design Patterns',
        difficulty: 'Easy',
        question: 'What is Dependency Injection?',
        options: [
            'A security feature to prevent SQL injection',
            'A design pattern where dependencies are provided externally',
            'A database pattern for efficient data retrieval',
            'A caching mechanism for static assets'
        ],
        correct: 1,
        explanation: 'Dependency Injection provides object dependencies from outside rather than creating them internally. Improves testability and loose coupling.'
    },
    {
        id: 42,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Factory Pattern?',
        options: [
            'A pattern for creating objects without specifying exact classes',
            'A database connectivity pattern',
            'A security pattern for authentication',
            'A UI pattern for widget creation'
        ],
        correct: 0,
        explanation: 'Factory Pattern provides an interface for creating objects, allowing subclasses to decide which class to instantiate. Promotes loose coupling.'
    },
    {
        id: 43,
        category: 'Design Patterns',
        difficulty: 'Hard',
        question: 'What is the Unit of Work pattern?',
        options: [
            'A pattern for unit testing individual components',
            'A pattern that maintains a list of objects affected by a business transaction',
            'A threading pattern for parallel processing',
            'A caching pattern for session data'
        ],
        correct: 1,
        explanation: 'Unit of Work tracks changes to objects during a business transaction and coordinates writing changes to the database. Often used with Repository pattern.'
    },
    {
        id: 44,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Observer Pattern?',
        options: [
            'A centralized logging pattern',
            'A pattern where objects notify observers of state changes',
            'A security auditing pattern',
            'A caching invalidation pattern'
        ],
        correct: 1,
        explanation: 'Observer Pattern defines a one-to-many dependency where state changes in one object automatically notify all dependent objects. Events in C# use this pattern.'
    },
    {
        id: 45,
        category: 'Design Patterns',
        difficulty: 'Easy',
        question: 'What is the purpose of the Builder Pattern?',
        options: [
            'To optimize database connection pooling',
            'To construct complex objects step by step',
            'To secure applications against XSS attacks',
            'To cache frequently accessed data items'
        ],
        correct: 1,
        explanation: 'Builder Pattern separates the construction of a complex object from its representation, allowing the same construction process to create different representations.'
    },

    // More Threading & Async
    {
        id: 46,
        category: 'Threading & Async',
        difficulty: 'Easy',
        question: 'What is a Task in C#?',
        options: [
            'A database operation queued for execution',
            'A representation of an asynchronous operation',
            'A UI component for displaying progress bars',
            'A security feature for managing user sessions'
        ],
        correct: 1,
        explanation: 'Task represents an asynchronous operation. It provides methods to wait for completion, check status, and get results from async operations.'
    },
    {
        id: 47,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is ConfigureAwait(false) used for?',
        options: [
            'To completely disable asynchronous operations in the current context',
            'To prevent capturing the current synchronization context',
            'To force the operation to run on the main UI thread',
            'To automatically handle all exceptions within the async method'
        ],
        correct: 1,
        explanation: 'ConfigureAwait(false) prevents capturing the current synchronization context, which can improve performance in library code and avoid deadlocks.'
    },
    {
        id: 48,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is the difference between Task.Run and async/await?',
        options: [
            'They are functionally identical and can be used interchangeably',
            'Task.Run queues CPU-bound work on the thread pool, async/await is for IO-bound ops',
            'Task.Run is deprecated in modern .NET versions',
            'async/await is significantly slower due to state machine overhead'
        ],
        correct: 1,
        explanation: 'Task.Run queues CPU-bound work on the thread pool. async/await is a language feature for writing asynchronous code. Use Task.Run for CPU work, async/await for I/O.'
    },
    {
        id: 49,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is a CancellationToken?',
        options: [
            'A security token used for API authentication',
            'A token for cooperative cancellation of async operations',
            'A database transaction identifier for rollback',
            'An authentication mechanism for OAuth providers'
        ],
        correct: 1,
        explanation: 'CancellationToken enables cooperative cancellation of asynchronous operations. Allows operations to be cancelled gracefully without aborting threads.'
    },
    {
        id: 50,
        category: 'Threading & Async',
        difficulty: 'Easy',
        question: 'What is thread safety?',
        options: [
            'Optimizing code to run on the fastest available thread',
            'Code that works correctly when accessed by multiple threads simultaneously',
            'Ensuring that threads are encrypted during execution',
            'Using the ThreadPool to manage thread lifecycles'
        ],
        correct: 1,
        explanation: 'Thread safety means code behaves correctly when accessed by multiple threads simultaneously, preventing race conditions and data corruption.'
    },

    // Additional Security Questions
    {
        id: 51,
        category: 'Security',
        difficulty: 'Easy',
        question: 'What is HTTPS and why is it important?',
        options: [
            'A faster version of HTTP used for media streaming',
            'HTTP with encryption using SSL/TLS protocols',
            'A new protocol designed specifically for REST APIs',
            'A database connection protocol for secure transfers'
        ],
        correct: 1,
        explanation: 'HTTPS encrypts data between client and server using SSL/TLS, protecting sensitive information from interception and ensuring data integrity.'
    },
    {
        id: 52,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is SQL Injection and how can it be prevented?',
        options: [
            'A database optimization technique for faster queries',
            'An attack where malicious SQL is inserted into queries via user input',
            'A caching strategy to reduce database load',
            'A connection method for secure SQL Server access'
        ],
        correct: 1,
        explanation: 'SQL Injection attacks insert malicious SQL code through user input. Prevent with parameterized queries, stored procedures, and input validation.'
    },
    {
        id: 53,
        category: 'Security',
        difficulty: 'Hard',
        question: 'What is the principle of least privilege?',
        options: [
            'Writing code that uses the minimum amount of system memory',
            'Granting only the minimum permissions necessary to perform a task',
            'Using the fewest lines of code to achieve a functionality',
            'Minimizing the number of API calls to external services'
        ],
        correct: 1,
        explanation: 'Least privilege means granting only the minimum permissions necessary for users/processes to complete their tasks, reducing security risks.'
    },
    {
        id: 54,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is CSRF (Cross-Site Request Forgery)?',
        options: [
            'A type of SQL injection attack targeting the database layer',
            'An attack that tricks authenticated users into executing unwanted actions',
            'A method for cracking user passwords using brute force',
            'A Distributed Denial of Service (DDoS) attack'
        ],
        correct: 1,
        explanation: 'CSRF tricks authenticated users into submitting malicious requests. Prevented with anti-forgery tokens that verify requests originate from your site.'
    },
    {
        id: 55,
        category: 'Security',
        difficulty: 'Easy',
        question: 'Why should passwords be hashed instead of encrypted?',
        options: [
            'Hashing is computationally faster than encryption',
            'Hashing is one-way, making it impossible to retrieve the original password',
            'Hashing uses significantly less storage space',
            'Encryption is considered deprecated for password storage'
        ],
        correct: 1,
        explanation: 'Hashing is one-way (cannot be reversed), while encryption is two-way. This means even if the database is compromised, passwords cannot be retrieved.'
    },

    // Performance & Best Practices
    {
        id: 56,
        category: 'Performance',
        difficulty: 'Easy',
        question: 'What is caching and why is it used?',
        options: [
            'A strategy for backing up database records',
            'Storing frequently accessed data in memory for faster retrieval',
            'A security measure to prevent unauthorized access',
            'A database optimization technique for indexing'
        ],
        correct: 1,
        explanation: 'Caching stores frequently accessed data in fast-access storage (memory) to reduce database calls and improve application performance.'
    },
    {
        id: 57,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is the difference between StringBuilder and String concatenation?',
        options: [
            'There is no performance difference between them',
            'StringBuilder is mutable and more efficient for multiple concatenations',
            'String concatenation is always faster for small strings',
            'StringBuilder is deprecated in .NET Core'
        ],
        correct: 1,
        explanation: 'String is immutable, creating new objects on each concatenation. StringBuilder is mutable and efficient for multiple string operations.'
    },
    {
        id: 58,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is Connection Pooling?',
        options: [
            'Creating multiple redundant database connections',
            'Reusing a pool of existing database connections',
            'A security feature for encrypting connections',
            'A caching mechanism for query results'
        ],
        correct: 1,
        explanation: 'Connection pooling maintains a pool of reusable database connections, avoiding the overhead of creating new connections for each request.'
    },
    {
        id: 59,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is lazy loading and when should it be used?',
        options: [
            'Execute code slowly to prevent CPU spikes',
            'Delaying initialization of objects until they are needed',
            'A security feature for validating user input',
            'A caching strategy for static resources'
        ],
        correct: 1,
        explanation: 'Lazy loading delays object initialization until the value is needed, saving resources. Useful for expensive operations or large objects that might not be used.'
    },
    {
        id: 60,
        category: 'Performance',
        difficulty: 'Easy',
        question: 'What is the purpose of using "using" statement with database connections?',
        options: [
            'To import the System.Data.SqlClient namespace',
            'To ensure connections are disposed and returned to the pool',
            'To increase the execution speed of SQL queries',
            'To automatically encrypt the connection string'
        ],
        correct: 1,
        explanation: 'The using statement ensures IDisposable objects like database connections are properly disposed, releasing resources and returning connections to the pool.'
    },

    // New C# Fundamentals Questions
    {
        id: 61,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is the purpose of the "params" keyword?',
        options: [
            'To specify generic type constraints',
            'To allow a method to accept a variable number of arguments',
            'To define output parameters for a method',
            'To declare parameters passed by reference'
        ],
        correct: 1,
        explanation: 'The "params" keyword allows a method to accept a variable number of arguments of a specified type, passed as a comma-separated list or an array.'
    },
    {
        id: 62,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is the difference between "const" and "readonly"?',
        options: [
            '"const" is evaluated at runtime, "readonly" at compile time',
            '"const" is compile-time constant, "readonly" is runtime constant',
            'They are interchangeable keywords',
            '"readonly" fields cannot be initialized in the constructor'
        ],
        correct: 1,
        explanation: '"const" is evaluated at compile-time and is implicitly static. "readonly" is evaluated at runtime and can be initialized in declaration or constructor.'
    },
    {
        id: 63,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is the purpose of "ref" and "out" keywords?',
        options: [
            '"ref" is for input only, "out" is for output only',
            'Both pass arguments by reference; "out" requires initialization',
            'Both pass by reference; "out" requires assignment before returning',
            'They are deprecated in favor of tuples'
        ],
        correct: 2,
        explanation: 'Both pass by reference. "ref" requires the variable to be initialized before passing. "out" requires the called method to assign a value before returning.'
    },
    {
        id: 64,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'What is an Extension Method?',
        options: [
            'A method that extends the class inheritance hierarchy',
            'A static method that appears to be an instance method on a type',
            'A plugin system for the Visual Studio IDE',
            'A dynamic method resolved at runtime'
        ],
        correct: 1,
        explanation: 'Extension methods allow adding methods to existing types without creating a new derived type, recompiling, or modifying the original type. defined as static methods in static classes.'
    },
    {
        id: 65,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is a Delegate?',
        options: [
            'A type that represents references to methods',
            'A pointer to a database record',
            'A UI event handler component',
            'A generic class for collections'
        ],
        correct: 0,
        explanation: 'A delegate is a type that represents references to methods with a particular parameter list and return type. Used for callbacks and event handling.'
    },
    {
        id: 66,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is the difference between an abstract class and an interface?',
        options: [
            'Abstract classes can have implementation, interfaces cannot (prior to C# 8.0)',
            'Reference types vs Value types',
            'Interfaces are slower due to boxing',
            'Abstract classes strictly do not support inheritance'
        ],
        correct: 0,
        explanation: 'Abstract classes can provide default implementation and state (fields). Interfaces define a contract. A class can inherit one abstract class but implement multiple interfaces.'
    },
    {
        id: 67,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is the "dynamic" type in C#?',
        options: [
            'A type that is strictly checked at compile-time',
            'A type that bypasses static type checking and is resolved at runtime',
            'A deprecated feature replaced by "var"',
            'An alias for the "object" type'
        ],
        correct: 1,
        explanation: 'The "dynamic" type bypasses compile-time type checking. Operations are resolved at runtime. Useful for interop with dynamic languages or COM.'
    },
    {
        id: 68,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is the difference between "break" and "continue"?',
        options: [
            '"break" exits the loop, "continue" skips to the next iteration',
            '"continue" exits the loop, "break" skips iteration',
            'They are functionally identical',
            '"break" is only used for switch statements'
        ],
        correct: 0,
        explanation: '"break" terminates the closest enclosing loop or switch statement. "continue" skips the rest of the current iteration and initiates the next one.'
    },
    {
        id: 69,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'What is the "yield" keyword used for?',
        options: [
            'To pause a thread execution for a specific time',
            'To indicate an iterator block that returns an element',
            'To stop compilation on error',
            'To yield CPU resources to another process'
        ],
        correct: 1,
        explanation: '"yield return" provides a value to the enumerator object and suspends execution. The next time the iterator is called, execution resumes from where it left off.'
    },
    {
        id: 70,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What are nullable types in C#?',
        options: [
            'Types that are strictly forbidden from being null',
            'Value types that can represent a normal value or a null value',
            'Reference types that can be null',
            'Anonymous types created at runtime'
        ],
        correct: 1,
        explanation: 'Nullable value types (e.g., int?) allow representing undefined values for value types that normally cannot be null. Based on System.Nullable<T>.'
    },
    {
        id: 71,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is the default access modifier for class members?',
        options: [
            'public',
            'internal',
            'private',
            'protected'
        ],
        correct: 2,
        explanation: 'The default access modifier for class members (fields, methods, etc.) is "private". For top-level classes, it is "internal".'
    },
    {
        id: 72,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is a partial class?',
        options: [
            'A class that is incompletely implemented',
            'A class definition split across multiple source files',
            'A base class for inheritance',
            'A deprecated feature in C# 2.0'
        ],
        correct: 1,
        explanation: 'A partial class definition allows splitting the code for a class, struct, or interface over two or more source files. Useful for generated code (like forms).'
    },
    {
        id: 73,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'What is the difference between "is" and "as" operators?',
        options: [
            '"is" checks compatibility, "as" attempts conversion',
            '"is" performs a cast, "as" checks type compatibility',
            'They are identical operators',
            '"as" throws an exception on conversion failure'
        ],
        correct: 0,
        explanation: '"is" checks if an object is compatible with a given type and returns generic boolean. "as" attempts conversion and returns null if it fails (instead of throwing).'
    },
    {
        id: 74,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What are Indexers?',
        options: [
            'Database indexes for performance',
            'Properties that allow objects to be indexed like arrays',
            'Search optimization algorithms',
            'Memory addresses for pointers'
        ],
        correct: 1,
        explanation: 'Indexers allow instances of a class or struct to be indexed just like arrays. Defined using the "this" keyword.'
    },
    {
        id: 75,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is the "finally" block used for?',
        options: [
            'To explicitly handle specific exception types that were skipped by catch blocks',
            'To execute code regardless of whether an exception occurred',
            'To define immutable variables that cannot be modified after initialization',
            'To force the immediate termination of the program state and clear memory'
        ],
        correct: 1,
        explanation: 'The "finally" block executes code after try/catch, regardless of whether an exception was thrown. Essential for resource cleanup.'
    },
    {
        id: 76,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is the difference between "throw" and "throw ex"?',
        options: [
            'There is no functional difference, it is just a stylistic choice',
            '"throw" preserves stack trace, "throw ex" resets it',
            '"throw ex" is significantly faster as it bypasses stack trace generation',
            '"throw" is deprecated and should be replaced by "throw ex" in modern C#'
        ],
        correct: 1,
        explanation: '"throw" preserves the original stack trace of the exception. "throw ex" resets the stack trace to the current method, losing original error context.'
    },
    {
        id: 77,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'What is the Checked and Unchecked context?',
        options: [
            'Security validation mechanism for checking user permissions',
            'Controls overflow checking for arithmetic operations',
            'A mechanism for verifying null references at runtime',
            'A compiler setting for strict type checking enforcement'
        ],
        correct: 1,
        explanation: 'Checked context throws exceptions on arithmetic overflow. Unchecked context truncates the result. Default depends on compiler settings (usually unchecked).'
    },
    {
        id: 78,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is an Enum?',
        options: [
            'A special class type that supports multiple inheritance',
            'A value type representing a set of named constants',
            'A reference type stored on the heap for shared access',
            'A dynamic type that can change its value at runtime'
        ],
        correct: 1,
        explanation: 'An Enum (enumeration) is a value type that defines a set of named constants. defaulting to int as the underlying type.'
    },
    {
        id: 79,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is the purpose of the "static" constructor?',
        options: [
            'To create static instances of a class from an external factory',
            'To initialize static members of the class',
            'To prevent the class from being instantiated by other classes',
            'To optimize memory by sharing the constructor across instances'
        ],
        correct: 1,
        explanation: 'A static constructor is called automatically before the first instance is created or any static members are referenced. Used to initialize static data.'
    },
    {
        id: 80,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'Review: What happens if a "finally" block throws an exception?',
        options: [
            'The new exception is ignored and the original exception continues',
            'The original exception is lost and the new one propagates',
            'Both exceptions are combined into an AggregateException',
            'The program crashes immediately with a StackOverflowException'
        ],
        correct: 1,
        explanation: 'If an exception is thrown in a finally block, the original pending exception (if any) is lost, and the new exception propagates up the stack.'
    },
    {
        id: 81,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What are Generic Constraints?',
        options: [
            'Performance limits placed on generic classes to prevent overuse',
            'Restrictions on the types that can be used as arguments for a generic parameter',
            'Database constraints automatically generated by Entity Framework',
            'Memory limits enforced by the Garbage Collector on generic interactions'
        ],
        correct: 1,
        explanation: 'Constraints (where T : class, etc.) restrict the types that can be used with generics, allowing the compiler to assume capabilities of the generic type.'
    },
    {
        id: 82,
        category: 'C# Fundamentals',
        difficulty: 'Easy',
        question: 'What is the "var" keyword?',
        options: [
            'A dynamic type that resolves at runtime like JavaScript var',
            'Implicitly typed local variable',
            'A global variable accessible across all classes in the namespace',
            'A variant type used for COM interoperability'
        ],
        correct: 1,
        explanation: '"var" allows the compiler to infer the type of the variable from the initialization expression at compile time. It is strongly typed.'
    },
    {
        id: 83,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What is a Destructor (Finalizer)?',
        options: [
            'A method that permanently deletes files from the disk',
            'Method called by GC before object reclamation to perform cleanup',
            'A manual method to force immediate object deletion',
            'A helper method to reset an object to its initial state'
        ],
        correct: 1,
        explanation: 'A finalizer (destructor) allows an object to perform necessary cleanup operations before being reclaimed by the Garbage Collector. Syntax: ~ClassName().'
    },
    {
        id: 84,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'What is the difference between "typeof" and "GetType()"?',
        options: [
            'They are functionally identical and can be used interchangeably',
            '"typeof" is an operator for compile-time types, "GetType" is a method for runtime objects',
            '"GetType" is a static method usually faster than the operator',
            '"typeof" returns a string representation of the class name'
        ],
        correct: 1,
        explanation: '"typeof(int)" gets the Type object for a type name at compile time. "obj.GetType()" gets the runtime Type of an instance.'
    },
    {
        id: 85,
        category: 'C# Fundamentals',
        difficulty: 'Medium',
        question: 'What are Records in C# (C# 9.0+)?',
        options: [
            'Specialized database records for Entity Framework integration',
            'Reference types with value-based equality semantics',
            'Lightweight structs optimized for high-performance computing',
            'Legacy classes maintained for backward compatibility'
        ],
        correct: 1,
        explanation: 'Records are reference types that provide built-in functionality for value-based equality, immutability, and concise syntax for data-centric models.'
    },
    {
        id: 86,
        category: 'C# Fundamentals',
        difficulty: 'Hard',
        question: 'What is the "stackalloc" keyword?',
        options: [
            'Allocates a block of memory explicitly on the Large Object Heap',
            'Allocates a block of memory on the stack',
            'Clears the stack memory to prevent overflow exceptions',
            'Reserves stack space specifically for recursion optimization'
        ],
        correct: 1,
        explanation: '"stackalloc" allocates a block of memory on the stack. fast allocation but requires "unsafe" context and is automatically freed when the method returns.'
    },

    // New ASP.NET Core Questions
    {
        id: 87,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is Kestrel?',
        options: [
            'A lightweight database engine for caching',
            'Use "Kestrel" as the cross-platform web server for ASP.NET Core',
            'A Razor view engine replacement for high performance',
            'A built-in testing framework for integration tests'
        ],
        correct: 1,
        explanation: 'Kestrel is a cross-platform web server for ASP.NET Core. It is the default web server included in ASP.NET Core project templates.'
    },
    {
        id: 88,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is the "Options Pattern" used for?',
        options: [
            'To dynamically generate dropdown menu options in MVC',
            'To provide strongly typed access to groups of related settings',
            'To configure advanced database connection options',
            'To manage global routing configurations'
        ],
        correct: 1,
        explanation: 'The Options pattern uses classes to provide strongly-typed access to groups of related settings. It supports validation, reloading, and dependency injection.'
    },
    {
        id: 89,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'What is the purpose of "UseRouting" and "UseEndpoints"?',
        options: [
            'To establish a secure connection to the database',
            'To define how the application matches HTTP requests to endpoints',
            'To optimize and compress static images served by the app',
            'To globally handle unhandled exceptions in the pipeline'
        ],
        correct: 1,
        explanation: 'UseRouting adds route matching to the middleware pipeline. UseEndpoints executes the matched delegate (like a controller action).'
    },
    {
        id: 90,
        category: 'ASP.NET Core',
        difficulty: 'Hard',
        question: 'What is the difference between "ConfigureServices" and "Configure" methods in Startup?',
        options: [
            'They are aliases for the same initialization process',
            'ConfigureServices takes dependencies, Configure sets up pipeline',
            'ConfigureServices registers services (DI), Configure defines the HTTP request pipeline',
            'Configure runs first and initializes the application state'
        ],
        correct: 2,
        explanation: 'ConfigureServices is used to register services with the Dependency Injection container. Configure is used to specify how the app responds to HTTP requests (middleware).'
    },
    {
        id: 91,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What are Minimal APIs?',
        options: [
            'Restricted APIs that only allow GET requests',
            'A lightweight way to build HTTP APIs without the overhead of Controllers',
            'APIs that run on a separate, slower thread to save resources',
            'Fully authenticated APIs that require minimal configuration'
        ],
        correct: 1,
        explanation: 'Minimal APIs allow building HTTP APIs with minimal dependencies and boilerplate code, using lambdas and method chaining instead of Controllers.'
    },
    {
        id: 92,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is a Tag Helper?',
        options: [
            'A helper method for parsing HTML tags in strings',
            'Server-side code that participates in creating and rendering HTML elements in Razor files',
            'A CSS class utility for rapid UI development',
            'A client-side JavaScript library for DOM manipulation'
        ],
        correct: 1,
        explanation: 'Tag Helpers enable server-side code to participate in creating and rendering HTML elements in Razor files. They look like standard HTML tags.'
    },
    {
        id: 93,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'What is Razor?',
        options: [
            'A lightweight CSS framework included with .NET',
            'A markup syntax for embedding server-based code into webpages',
            'A built-in lightweight database similar to SQLite',
            'A browser engine used for rendering views'
        ],
        correct: 1,
        explanation: 'Razor is a markup syntax that lets you embed server-based code (C#) into webpages. Used in MVC Views and Razor Pages.'
    },
    {
        id: 94,
        category: 'ASP.NET Core',
        difficulty: 'Hard',
        question: 'What is the order of execution for ASP.NET Core Filters?',
        options: [
            'Resource -> Authorization -> Action -> Result -> Exception',
            'Authorization -> Resource -> Action -> Exception -> Result',
            'Authorization -> Resource -> Action -> Result -> Exception',
            'Action -> Authorization -> Resource -> Result -> Exception'
        ],
        correct: 1,
        explanation: 'Typical order: Authorization -> Resource -> Action -> Exception -> Result. (Exception filters run if methods throw).'
    },
    {
        id: 95,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is Data Annotations used for?',
        options: [
            'Enhancing database performance through indexing hints',
            'Attribute-based data validation and modeling',
            'Adding developer comments that appear in Swagger docs',
            'Configuring logging levels for specific properties'
        ],
        correct: 1,
        explanation: 'Data Annotations provide a declarative way to apply validation rules and formatting to model properties using attributes like [Required], [StringLength].'
    },
    {
        id: 96,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'How do you access the current environment name?',
        options: [
            'Access it directly through System.Environment.Current',
            'IWebHostEnvironment.EnvironmentName',
            'Read it from the web.config file',
            'Access it via a global static variable'
        ],
        correct: 1,
        explanation: 'Inject IWebHostEnvironment (or IHostEnvironment) and access the EnvironmentName property. Also use helper methods like IsDevelopment().'
    },
    {
        id: 97,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is the purpose of "UseStaticFiles"?',
        options: [
            'To enable the usage of static variables in controllers',
            'To serve static files (HTML, CSS, images) from the wwwroot folder',
            'To lock critical files preventing them from being modified',
            'To aggressively cache all files in memory'
        ],
        correct: 1,
        explanation: 'UseStaticFiles middleware enables the application to serve static files like HTML, CSS, images, and JavaScript, typically from the "wwwroot" directory.'
    },
    {
        id: 98,
        category: 'ASP.NET Core',
        difficulty: 'Hard',
        question: 'What is Blazor?',
        options: [
            'A server-side template engine similar to Razor Pages',
            'A framework for building interactive client-side web UI with .NET instead of JavaScript',
            'A dedicated web server for high-performance applications',
            'A NoSQL database integrated into .NET Core'
        ],
        correct: 1,
        explanation: 'Blazor allows building interactive web UIs using C# instead of JavaScript. It can run on the server (Blazor Server) or in the browser via WebAssembly (Blazor WebAssembly).'
    },
    {
        id: 99,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is SignalR?',
        options: [
            'A standard library for writing logs to disk',
            'A library for adding real-time web functionality to apps',
            'A relational database engine for .NET',
            'A routing engine for single-page applications'
        ],
        correct: 1,
        explanation: 'SignalR is a library that simplifies adding real-time web functionality to apps, allowing server-side code to push content to clients instantly.'
    },
    {
        id: 100,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'What is "wwwroot"?',
        options: [
            'The namespace root for the entire application',
            'The default directory for static files',
            'The default administrator user account',
            'The connection string to the root database'
        ],
        correct: 1,
        explanation: 'wwwroot is the default web root directory for ASP.NET Core apps. Static files like CSS, JS, and images must be placed here to be served.'
    },
    {
        id: 101,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is the BindingSource in Model Binding?',
        options: [
            'The primary data source from which the entire model is populated',
            'Attributes that specify where to find a model value (e.g., [FromQuery], [FromBody])',
            'The internal configuration object used by the DefaultModelBinder',
            'The view model passed from the controller to the view'
        ],
        correct: 1,
        explanation: 'Binding Source attributes ([FromQuery], [FromRoute], [FromBody], [FromHeader], [FromForm]) tell the model binder where to look for values.'
    },
    {
        id: 102,
        category: 'ASP.NET Core',
        difficulty: 'Hard',
        question: 'What happens if you register a Scoped service in a Singleton service?',
        options: [
            'It works perfectly as the dependency injector handles the scope promotion automatically',
            'The Scoped service becomes a Singleton (Captive Dependency)',
            'It throws a runtime exception during the application startup phase',
            'It creates a new independent scope for the service every time it is accessed'
        ],
        correct: 1,
        explanation: 'This is a "Captive Dependency". The Scoped service is injected once into the Singleton and lives for the application lifetime, violating its intended lifecycle.'
    },
    {
        id: 103,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is a ViewComponent?',
        options: [
            'A simpler version of a controller that only returns JSON data',
            'Similar to a partial view but with an associated C# class',
            'A deprecated legacy component from ASP.NET Web Forms',
            'A layout file used to define the common structure of multiple views'
        ],
        correct: 1,
        explanation: 'ViewComponents are like mini-controllers. They consist of a C# class and a view file. Ideal for reusable rendering logic (dynamic menus, login panels).'
    },
    {
        id: 104,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'How do you handle exceptions globally in ASP.NET Core?',
        options: [
            'Wrap every controller action validation code in try-catch blocks',
            'Use specific Exception Handling Middleware (UseExceptionHandler)',
            'It is automatically handled by the Kestrel web server',
            'Use the "global.asax" file to define application-level error events'
        ],
        correct: 1,
        explanation: 'Use the "UseExceptionHandler" middleware to handle exceptions globally. You can also use "UseDeveloperExceptionPage" for development environment.'
    },
    {
        id: 105,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What are Areas used for?',
        options: [
            'Logical partitioning of database tables for performance',
            'Partitioning an ASP.NET Core app into smaller functional groupings',
            'Defining distinct CSS styling zones for different pages',
            'Creating security zones with different authentication requirements'
        ],
        correct: 1,
        explanation: 'Areas provide a way to partition an ASP.NET Core Web app into smaller functional groups, each with its own set of Razor Pages, Controllers, Views, and Models.'
    },
    {
        id: 106,
        category: 'ASP.NET Core',
        difficulty: 'Hard',
        question: 'What is Health Checks middleware?',
        options: [
            'A security middleware that scans uploaded files for viruses',
            'Middleware to report the health of app components (DB, disk, etc.)',
            'A performance profiling tool included in the .NET SDK',
            'A component for tracking user physical activity data'
        ],
        correct: 1,
        explanation: 'Health Checks Middleware provides a way to expose the health status of your application and its dependencies (like database availability) via an HTTP endpoint.'
    },
    {
        id: 107,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is Distributed Caching?',
        options: [
            'Caching data strictly on the client-side browser storage',
            'Cache shared by multiple app servers (e.g., Redis, SQL Server)',
            'Caching instructions directly in the CPU L2/L3 cache',
            'A method of caching files locally on the web server disk'
        ],
        correct: 1,
        explanation: 'Distributed caching stores data in an external service (like Redis or SQL Server) shared by multiple app servers. ensuring consistency in a load-balanced environment.'
    },
    {
        id: 108,
        category: 'ASP.NET Core',
        difficulty: 'Easy',
        question: 'What is ILogger used for?',
        options: [
            'A system for managing user login sessions',
            'A generic interface for logging',
            'A processing engine for business logic rules',
            'A load balancing algorithm for handling requests'
        ],
        correct: 1,
        explanation: 'ILogger<T> is the standard interface for logging in .NET Core. It supports structured logging and multiple output providers (Console, Debug, EventSource, etc.).'
    },
    {
        id: 109,
        category: 'ASP.NET Core',
        difficulty: 'Hard',
        question: 'What is HSTS (HTTP Strict Transport Security)?',
        options: [
            'A high-performance implementation of the HTTP protocol',
            'Security header that forces browsers to use HTTPS',
            'A binary transport protocol for efficient data transfer',
            'A deprecated HTML standard for strict document validation'
        ],
        correct: 1,
        explanation: 'HSTS is a security header that tells the browser to only interact with the server using a secure HTTPS connection, preventing protocol downgrade attacks.'
    },
    {
        id: 110,
        category: 'ASP.NET Core',
        difficulty: 'Medium',
        question: 'What is the difference between [FromBody] and [FromForm]?',
        options: [
            'They are functionally identical and use the same formatter',
            '[FromBody] reads from request body (JSON), [FromForm] reads from form data',
            '[FromBody] is deprecated in favor of manual stream reading',
            '[FromForm] is significantly faster for small payloads'
        ],
        correct: 1,
        explanation: '[FromBody] infers data from the request body (typically JSON/XML). [FromForm] infers data from form-urlencoded data (HTML form submissions, file uploads).'
    },

    // New Entity Framework Questions
    {
        id: 111,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is the Fluent API?',
        options: [
            'A specific syntax for writing LINQ queries',
            'A way to configure the model using code in OnModelCreating',
            'A command-line tool for managing database migrations',
            'A format for specifying database connection strings'
        ],
        correct: 1,
        explanation: 'Fluent API allows you to configure your model classes and database schema using method chaining in the DbContext.OnModelCreating method. It is more powerful than Data Annotations.'
    },
    {
        id: 112,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What are Global Query Filters?',
        options: [
            'Filters that run on every query for a specific entity type',
            'Filters that apply indiscriminately to all entities in the context',
            'Stored procedures that execute on the database server',
            'Client-side filters applied after data retrieval'
        ],
        correct: 0,
        explanation: 'Global Query Filters are LINQ query predicates applied to Entity Types in the model (e.g., in OnModelCreating). Common use case is implementing "Soft Delete".'
    },
    {
        id: 113,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is Concurrency Token in EF Core?',
        options: [
            'A security token issued upon successful login',
            'A property used to detect concurrent updates (Optimistic Concurrency)',
            'A lock object used for thread synchronization',
            'A unique identifier for database transactions'
        ],
        correct: 1,
        explanation: 'A Concurrency Token (like a Timestamp/RowVersion) is checked during database updates. If the value in the DB matches the original value, the update proceeds; otherwise, a concurrency exception occurs.'
    },
    {
        id: 114,
        category: 'Entity Framework',
        difficulty: 'Easy',
        question: 'What is "Include()" used for?',
        options: [
            'To import external namespaces into the file',
            'To specify related data to be loaded (Eager Loading)',
            'To filter the data based on specific conditions',
            'To sort the data in ascending or descending order'
        ],
        correct: 1,
        explanation: 'Include() specifies related entities to include in the query result. This is known as Eager Loading.'
    },
    {
        id: 115,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is the difference between OnConfiguring and OnModelCreating?',
        options: [
            'They are aliases for the same configuration method',
            'OnConfiguring sets up DB connection/providers, OnModelCreating configures the model',
            'OnModelCreating runs first before the context is initialized',
            'OnConfiguring is deprecated and removed in EF Core'
        ],
        correct: 1,
        explanation: 'OnConfiguring is used to ensure the context is configured (e.g., setting connection string). OnModelCreating is used to map entities to the database schema.'
    },
    {
        id: 116,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What are Owned Entity Types?',
        options: [
            'Entities that are legally owned by a specific user account',
            'Types that can only appear as navigation properties of other entity types',
            'Abstract base classes that cannot be instantiated',
            'Read-only database views mapped to entities'
        ],
        correct: 1,
        explanation: 'Owned Entity Types allow you to model types that don\'t have their own identity (primary key) in the database but are conceptual parts of another entity (e.g., Address part of User).'
    },
    {
        id: 117,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is Table Splitting?',
        options: [
            'Partitioning a large table into smaller files',
            'Mapping multiple entities to a single table',
            'Creating database views for complex queries',
            'Distributing a database across multiple servers (Sharding)'
        ],
        correct: 1,
        explanation: 'Table Splitting allows mapping multiple entity types to the same database table. Primary keys must match. Useful for separating rarely accessed columns.'
    },
    {
        id: 118,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What is TPH (Table Per Hierarchy)?',
        options: [
            'Creating a separate table for every class in the hierarchy',
            'Storing an entire inheritance hierarchy in a single table with a discriminator column',
            'A database normalization technique to reduce redundancy',
            'A known performance anti-pattern in EF Core'
        ],
        correct: 1,
        explanation: 'TPH is an inheritance mapping strategy where all classes in a hierarchy are mapped to a single table. A "Discriminator" column identifies the specific type of each row.'
    },
    {
        id: 119,
        category: 'Entity Framework',
        difficulty: 'Easy',
        question: 'What is DbSet<T>?',
        options: [
            'A configuration setting for the database',
            'A collection representing a table in the database',
            'The connection string used to connect to the DB',
            'A raw SQL query object'
        ],
        correct: 1,
        explanation: 'DbSet<T> represents the collection of all entities in the context, or that can be queried from the database, of a given type.'
    },
    {
        id: 120,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is Reverse Engineering (Scaffolding)?',
        options: [
            'Decompiling the database engine executable',
            'Generating entity classes and DbContext from an existing database',
            'Migrating from Code First to Database First',
            'A strategy for unit testing the database layer'
        ],
        correct: 1,
        explanation: 'Scaffolding (Reverse Engineering) is the process of generating entity type classes and a DbContext class based on an existing database schema.'
    },
    {
        id: 121,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'How do you execute raw SQL queries in EF Core?',
        options: [
            'It is only possible using classic ADO.NET',
            'Using FromSqlRaw or FromSqlInterpolated methods',
            'It is strictly prohibited for security reasons',
            'By manually constructing SQL strings and injecting them'
        ],
        correct: 1,
        explanation: 'FromSqlRaw and FromSqlInterpolated allow executing raw SQL queries that return entity instances. ExecuteSqlRaw is used for non-query commands.'
    },
    {
        id: 122,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What is the "HiLo" algorithm?',
        options: [
            'A common sorting algorithm used in databases',
            'A key generation strategy involving client and server cooperation',
            'A binary search optimization algorithm',
            'A data compression method for saving space'
        ],
        correct: 1,
        explanation: 'HiLo is a key generation pattern where the client generates a range of keys (Low) based on a value allocated by the database (High), reducing database round-trips for ID generation.'
    },
    {
        id: 123,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is Client vs Server Evaluation?',
        options: [
            'Evaluating code quality on client vs server',
            'Deciding which parts of a query run on the database (Server) vs in memory (Client)',
            'A security mechanism for validating requests',
            'A load balancing strategy for distributing traffic'
        ],
        correct: 1,
        explanation: 'EF Core tries to translate queries to SQL (Server Evaluation). If it can\'t, it may throw an exception or evaluate parts locally (Client Evaluation - restricted in modern EF Core).'
    },
    {
        id: 124,
        category: 'Entity Framework',
        difficulty: 'Easy',
        question: 'What allows EF Core to work with different databases?',
        options: [
            'Magic and hardcoded strings',
            'Database Providers (e.g., Microsoft.EntityFrameworkCore.SqlServer)',
            'A universal SQL dialect shared by all databases',
            'The .NET Standard Library base classes'
        ],
        correct: 1,
        explanation: 'Database Providers are plugins libraries resulting in an abstraction layer that allows EF Core to interact with specific database engines (SQL Server, Postgres, SQLite, etc.).'
    },
    {
        id: 125,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is a Value Converter?',
        options: [
            'Module for converting currency values automatically',
            'Converts property values when reading from or writing to the database',
            'A strict type casting mechanism',
            'A JSON serializer for web APIs'
        ],
        correct: 1,
        explanation: 'Value Converters allow configuration of how property values are converted when writing to the database and reading back (e.g., storing an Enum as a string).'
    },
    {
        id: 126,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What is Connection Resiliency?',
        options: [
            'Keeping the database connection open indefinitely',
            'Automatically retrying failed database commands (e.g. transient faults)',
            'A protocol for faster database handshakes',
            'A method for encrypting database connections'
        ],
        correct: 1,
        explanation: 'Connection Resiliency automatically retries failed database commands. You can configure an "Execution Strategy" (like EnableRetryOnFailure) to handle transient errors.'
    },
    {
        id: 127,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is the difference between IQueryable and IEnumerable in EF context?',
        options: [
            'They are functionally identical in all contexts',
            'IQueryable builds SQL, IEnumerable executes immediately (loads into memory)',
            'IEnumerable is significantly better for filtering large datasets',
            'IQueryable is deprecated and should be avoided'
        ],
        correct: 1,
        explanation: 'IQueryable allows query composition and translation to SQL. IEnumerable executes the query and brings data into memory, meaning further operations happen on the client.'
    },
    {
        id: 128,
        category: 'Entity Framework',
        difficulty: 'Easy',
        question: 'What is the default tracking behavior for queries?',
        options: [
            'NoTracking',
            'Tracking',
            'IdentityResolution',
            'TrackAll'
        ],
        correct: 1,
        explanation: 'By default, queries that return entity types are "Tracking". The context snapshots them and tracks changes for SaveChanges(). Use AsNoTracking for read-only.'
    },
    {
        id: 129,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is TPT (Table Per Type)?',
        options: [
            'One single giant table for all types',
            'Separate tables for each class in inheritance hierarchy',
            'One table per database schema',
            'No tables, data is stored in JSON files'
        ],
        correct: 1,
        explanation: 'TPT maps every class in the inheritance hierarchy to its own table. Tables for derived classes contain only their specific columns and a foreign key to the base table.'
    },
    {
        id: 130,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What are Compiled Models in EF Core 6+?',
        options: [
            'Pre-generated database migrations',
            'Optimized code generated from the model to improve startup time',
            'Standard database views',
            'Binary serialized models'
        ],
        correct: 1,
        explanation: 'Compiled Models allow generating optimized code for the model at design time, significantly reducing the startup time (cold start) of the application.'
    },
    {
        id: 131,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'How do you handle Many-to-Many relationships in EF Core 5+?',
        options: [
            'You must manually create a join table entity',
            'It is automatically handled without explicit join entity (skip navigation)',
            'It is not supported and requires a workaround',
            'By using JSON columns to store related IDs'
        ],
        correct: 1,
        explanation: 'In EF Core 5+, many-to-many relationships can be configured without an explicit join entity. EF Core automatically manages the join table behind the scenes.'
    },
    {
        id: 132,
        category: 'Entity Framework',
        difficulty: 'Easy',
        question: 'What does SaveChanges() do?',
        options: [
            'Saves the current file to the local disk',
            'Applies all tracked changes to the database',
            'Validates data without saving to the database',
            'Commits the current transaction without writing data'
        ],
        correct: 1,
        explanation: 'SaveChanges() orchestrates writing all changes (inserts, updates, deletes) detected by the Change Tracker to the database, usually in a transaction.'
    },
    {
        id: 133,
        category: 'Entity Framework',
        difficulty: 'Medium',
        question: 'What is an InMemory database provider used for?',
        options: [
            'For high-performance production data storage',
            'Testing purposes',
            'As a distributed caching layer like Redis',
            'For long-term archival storage'
        ],
        correct: 1,
        explanation: 'The InMemory provider is a general purpose database designed for testing. It stores data in the process memory and is lost when the app stops.'
    },
    {
        id: 134,
        category: 'Entity Framework',
        difficulty: 'Hard',
        question: 'What is Explicit Loading?',
        options: [
            'Loading all related data immediately (Eager Loading)',
            'Loading related data via the entry API (e.g. context.Entry(blog).Collection(b => b.Posts).Load())',
            'Loading data automatically when accessed (Lazy Loading)',
            'Loading configuration data from appsettings.json'
        ],
        correct: 1,
        explanation: 'Explicit Loading allows you to load related data at a later time explicitly via the DbContext Entry API. Useful when you need more control than Lazy Loading.'
    },

    // New LINQ Questions
    {
        id: 135,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is the purpose of "GroupBy"?',
        options: [
            'To sort elements in ascending order',
            'To group elements of a sequence according to a specified key',
            'To filter elements based on a predicate',
            'To join two sequences into a single flat list'
        ],
        correct: 1,
        explanation: 'GroupBy groups elements that share a common key. The result is a sequence of IGrouping<Key, Element> objects.'
    },
    {
        id: 136,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is the difference between "ToDictionary" and "ToLookup"?',
        options: [
            'They are functionally identical aliases',
            'ToDictionary enforces unique keys, ToLookup allows duplicate keys (grouping)',
            'ToLookup is significantly faster for single-item lookups',
            'ToDictionary is deprecated in modern .NET'
        ],
        correct: 1,
        explanation: 'ToDictionary throws an exception if duplicate keys are encountered. ToLookup handles duplicate keys by grouping values under the key (returning an ILookup).'
    },
    {
        id: 137,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What does "Skip" and "Take" do?',
        options: [
            'Skip deletes data, Take restores it',
            'Skip bypasses a number of elements, Take returns a specified number of contiguous elements',
            'Skip sorts in descending order, Take sorts in ascending order',
            'Skip randomly samples data, Take selects the first item'
        ],
        correct: 1,
        explanation: 'Skip(n) bypasses the first n elements. Take(n) returns the first n elements. Commonly used together for pagination.'
    },
    {
        id: 138,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is the difference between "Single" and "SingleOrDefault"?',
        options: [
            'They are functionally identical',
            'Single throws if not exactly one element; SingleOrDefault returns default if empty (but still throws if multiple)',
            'Single returns the first match found, ignoring others',
            'SingleOrDefault returns null if multiple matches are found'
        ],
        correct: 1,
        explanation: 'Single throws if collection is empty OR has >1 items. SingleOrDefault returns default if empty, but STILL throws if >1 items. Use FirstOrDefault if >1 is possible.'
    },
    {
        id: 139,
        category: 'LINQ',
        difficulty: 'Hard',
        question: 'What is "Aggregate" used for?',
        options: [
            'To count the number of items in a sequence',
            'To perform a custom accumulation operation on a sequence (like reduce)',
            'To sort items based on a custom comparer',
            'To filter items using complex logic'
        ],
        correct: 1,
        explanation: 'Aggregate applies an accumulator function over a sequence. Example: calculating factorial or concatenating strings. It reduces the sequence to a single value.'
    },
    {
        id: 140,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "Zip"?',
        options: [
            'A file compression algorithm',
            'Merges two sequences by using a specified predicate function',
            'Removes duplicate elements from a list',
            'Splits a single sequence into multiple lists'
        ],
        correct: 1,
        explanation: 'Zip combines two sequences like a zipper, processing pairs of elements (one from each sequence) using a specified function to produce a result sequence.'
    },
    {
        id: 141,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What is "All"?',
        options: [
            'Returns all elements in the sequence',
            'Determines whether all elements of a sequence satisfy a condition',
            'Removes all elements from the list',
            'Sorts all elements via default comparer'
        ],
        correct: 1,
        explanation: 'All() checks if every element in the sequence matches the predicate. Returns true only if ALL match. Returns true for empty sequences (vacuous truth).'
    },
    {
        id: 142,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "SelectMany" useful for?',
        options: [
            'Selecting multiple columns from a table',
            'Flattening one-to-many relationships (e.g. List of Lists -> Single List)',
            'Filtering based on multiple conditions',
            'Grouping items by multiple keys'
        ],
        correct: 1,
        explanation: 'SelectMany projects each element of a sequence to an IEnumerable<T> and flattens the resulting sequences into one sequence. Perfect for nested lists.'
    },
    {
        id: 143,
        category: 'LINQ',
        difficulty: 'Hard',
        question: 'What is the difference between "Join" and "GroupJoin"?',
        options: [
            'There is no difference in functionality',
            'Join is like SQL INNER JOIN (flat), GroupJoin is like LEFT OUTER JOIN (hierarchical)',
            'Join is faster for large datasets',
            'GroupJoin is deprecated in standard LINQ'
        ],
        correct: 1,
        explanation: 'Join correlates elements of two sequences based on matching keys (flat result). GroupJoin correlates elements and produces a hierarchical result (key + collection of matches).'
    },
    {
        id: 144,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What does "Distinct" do?',
        options: [
            'Sorts the data distinctively',
            'Returns distinct elements from a sequence (removes duplicates)',
            'Counts the number of distinct elements',
            'Reverses the elements'
        ],
        correct: 1,
        explanation: 'Distinct returns a new sequence with duplicate elements removed. Uses default equality comparer or a specified one.'
    },
    {
        id: 145,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "OfType<T>"?',
        options: [
            'A hard cast that throws on failure',
            'Filters the elements of an IEnumerable based on a specified type',
            'Sorts elements by their type name',
            'Groups elements by their type'
        ],
        correct: 1,
        explanation: 'OfType<T>() filters a sequence, returning only those elements that can be cast to type T. Unlike Cast<T>(), it does not throw execution if cast fails, it just skips.'
    },
    {
        id: 146,
        category: 'LINQ',
        difficulty: 'Hard',
        question: 'What is PLINQ?',
        options: [
            'Private LINQ implementation',
            'Parallel LINQ - implementation of LINQ to Objects that supports parallel execution',
            'Python LINQ interoperability layer',
            'Performance LINQ profiler'
        ],
        correct: 1,
        explanation: 'PLINQ (Parallel LINQ) enables parallel execution of LINQ queries. Use .AsParallel() to start. It can utilize multiple processors to speed up CPU-bound operations.'
    },
    {
        id: 147,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "DefaultIfEmpty"?',
        options: [
            'Clears the list if it contains errors',
            'Returns the elements of the specified sequence or the type\'s default value in a singleton collection if the sequence is empty',
            'Checks if the collection is null',
            'Throws an exception if the list is empty'
        ],
        correct: 1,
        explanation: 'DefaultIfEmpty returns a new IEnumerable containing the default value (null or 0) if the source sequence is empty. Often used to implement Left Outer Joins.'
    },
    {
        id: 148,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What is "Union"?',
        options: [
            'Joins strings together',
            'Produces the set union of two sequences (unique elements from both)',
            'Duplicates data from both lists',
            'Splits data into two unions'
        ],
        correct: 1,
        explanation: 'Union produces a sequence containing unique elements that appear in either of the two input sequences.'
    },
    {
        id: 149,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "Intersect"?',
        options: [
            'Draws lines on a graph',
            'Produces the set intersection of two sequences (elements present in both)',
            'Combines two lists including duplicates',
            'Removes all data from both lists'
        ],
        correct: 1,
        explanation: 'Intersect returns a sequence containing elements that appear in BOTH input sequences.'
    },
    {
        id: 150,
        category: 'LINQ',
        difficulty: 'Hard',
        question: 'What happens with Closures in LINQ?',
        options: [
            'Closures are not supported in LINQ',
            'Variables captured in a lambda are evaluated when the query executes, not when defined',
            'Variables are copied by value at definition time',
            'Lambdas are pre-compiled into static methods'
        ],
        correct: 1,
        explanation: 'Captured variables in lambdas (closures) are evaluated when the query is executed (deferred execution). If the variable changes before execution, the query uses the *new* value.'
    },
    {
        id: 151,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "ElementAt"?',
        options: [
            'Searches for an element by value',
            'Returns the element at a specified index in a sequence',
            'Finds the first matching element',
            'Finds the last matching element'
        ],
        correct: 1,
        explanation: 'ElementAt returns the element at the specified index. Throws if index is out of range. Use ElementAtOrDefault to return null/default instead of throwing.'
    },
    {
        id: 152,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What is the "let" keyword in query syntax?',
        options: [
            'Defines a global variable',
            'Stores the result of a sub-expression for subsequent use in the query',
            'Sets user permissions',
            'Filters the results'
        ],
        correct: 1,
        explanation: 'The "let" clause allows you to store the result of an expression (like a calculation or sub-query) in a new range variable for use in subsequent clauses.'
    },
    {
        id: 153,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "SequenceEqual"?',
        options: [
            'Checks if two sequences have the same length',
            'Determines whether two sequences are equal by comparing the elements',
            'Checks if two sequences point to the same reference',
            'Checks if two sequences are of the same type'
        ],
        correct: 1,
        explanation: 'SequenceEqual checks if two sequences contain the same elements in the same order and count.'
    },
    {
        id: 154,
        category: 'LINQ',
        difficulty: 'Hard',
        question: 'What are Expression Trees?',
        options: [
            'UI component trees',
            'Data structures that represent code in a tree-like format, allowing dynamic modification and translation (e.g. to SQL)',
            'Binary search trees',
            'Sorting algorithms'
        ],
        correct: 1,
        explanation: 'Expression Trees represent code as data structures. LINQ providers (like EF Core) use them to inspect the query structure and translate it into domain-specific code (like SQL).'
    },
    {
        id: 155,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is difference between "Concat" and "Union"?',
        options: [
            'No functional difference',
            'Concat treats duplicates as distinct items, Union removes duplicates',
            'Union is faster for all operations',
            'Concat is deprecated in .NET 6+'
        ],
        correct: 1,
        explanation: 'Concat simply appends the second sequence to the first (preserving duplicates). Union returns unique elements from both.'
    },
    {
        id: 156,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What is "Reverse"?',
        options: [
            'Undoes the last database change',
            'Inverts the order of the elements in a sequence',
            'Sorts the list in descending order',
            'Swaps the first and last items'
        ],
        correct: 1,
        explanation: 'Reverse simply inverts the order of elements in the sequence.'
    },
    {
        id: 157,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is AsEnumerable used for?',
        options: [
            'Converts an array to a List',
            'Casts to IEnumerable, often to switch from server-side evaluation (IQueryable) to client-side (LINQ to Objects)',
            'Validates the sequence allows enumeration',
            'Serializes the sequence to JSON'
        ],
        correct: 1,
        explanation: 'AsEnumerable() casts the sequence to IEnumerable<T>. In EF, this stops building the SQL query and forces the remainder of the query to execute in-memory (Client-Side).'
    },
    {
        id: 158,
        category: 'LINQ',
        difficulty: 'Hard',
        question: 'What is "Except"?',
        options: [
            'Handles exceptions in the query',
            'Produces the set difference of two sequences',
            'Filters out null values',
            'Selects only unique elements'
        ],
        correct: 1,
        explanation: 'Except returns elements that appear in the first sequence but NOT in the second sequence.'
    },
    {
        id: 159,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "AsQueryable"?',
        options: [
            'Converts a List to an Array',
            'Converts IEnumerable to IQueryable',
            'Optimizes the query performance',
            'Validates the query syntax'
        ],
        correct: 1,
        explanation: 'AsQueryable converts an IEnumerable to IQueryable. Useful if you want to use the IQueryable methods or mock a database set.'
    },
    {
        id: 160,
        category: 'LINQ',
        difficulty: 'Easy',
        question: 'What is "Count" vs "LongCount"?',
        options: [
            'No difference',
            'Count returns int, LongCount returns long (for very large sequences)',
            'Count is faster',
            'LongCount is more precise'
        ],
        correct: 1,
        explanation: 'Count returns an Int32. LongCount returns an Int64. Use LongCount if the result might exceed 2 billion.'
    },
    {
        id: 161,
        category: 'LINQ',
        difficulty: 'Medium',
        question: 'What is "ThenBy"?',
        options: [
            'Filters the data before sorting',
            'Performs a secondary sort on an already sorted sequence',
            'Groups data by a unique secondary key',
            'Projects the data into a new type for sorting'
        ],
        correct: 1,
        explanation: 'ThenBy (and ThenByDescending) performs a subsequent ordering of elements in a sequence that has already been sorted (e.g. OrderBy(...).ThenBy(...)).'
    },

    // New Design Patterns Questions
    {
        id: 162,
        category: 'Design Patterns',
        difficulty: 'Easy',
        question: 'What is the "S" in SOLID?',
        options: [
            'Simple Responsibility Principle',
            'Single Responsibility Principle',
            'Static Responsibility Principle',
            'Secure Responsibility Principle'
        ],
        correct: 1,
        explanation: 'Single Responsibility Principle (SRP): A class should have only one reason to change, meaning it should have only one job or responsibility.'
    },
    {
        id: 163,
        category: 'Design Patterns',
        difficulty: 'Easy',
        question: 'What is the "O" in SOLID?',
        options: [
            'Open/Closed Principle',
            'Object Oriented Principle',
            'Optional Principle',
            'Overload Principle'
        ],
        correct: 0,
        explanation: 'Open/Closed Principle: Software entities (classes, modules, functions, etc.) should be open for extension but closed for modification.'
    },
    {
        id: 164,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Liskov Substitution Principle (LSP)?',
        options: [
            'Subtypes must be substitutable for their base types without altering correctness',
            'Linked lists should be substitutable for arrays in performance-critical code',
            'Lambda expressions should be substitutable for delegates',
            'Loop substitution principle for optimizing iteration'
        ],
        correct: 0,
        explanation: 'LSP states that objects of a superclass shall be replaceable with objects of its subclasses without breaking the application.'
    },
    {
        id: 165,
        category: 'Design Patterns',
        difficulty: 'Easy',
        question: 'What is the "I" in SOLID?',
        options: [
            'Inheritance Segregation Principle',
            'Interface Segregation Principle',
            'Instantiation Principle',
            'Iteration Principle'
        ],
        correct: 1,
        explanation: 'Interface Segregation Principle: Clients should not be forced to depend upon interfaces that they do not use. Many client-specific interfaces are better than one general-purpose interface.'
    },
    {
        id: 166,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Dependency Inversion Principle (DIP)?',
        options: [
            'Dependencies should be inverted using pointers',
            'High-level modules should not depend on low-level modules. Both should depend on abstractions',
            'Database dependencies should be hardcoded for performance',
            'UI dependencies should dictate business logic structure'
        ],
        correct: 1,
        explanation: 'DIP states that high-level modules should not depend on low-level modules; both should depend on abstractions. Abstractions should not depend on details.'
    },
    {
        id: 167,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Adapter Pattern?',
        options: [
            'A database connector strategy',
            'Allows incompatible interfaces to work together by wrapping one object',
            'Strategies for adapting UI layouts to mobile screens',
            'A method for parsing XML data into objects'
        ],
        correct: 1,
        explanation: 'Adapter Pattern allows objects with incompatible interfaces to collaborate. It acts as a wrapper between two objects. (Structural Pattern)'
    },
    {
        id: 168,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Decorator Pattern?',
        options: [
            'A UI styling framework',
            'Attaches additional responsibilities to an object dynamically',
            'A garbage collection optimization technique',
            'A factory for creating complex object graphs'
        ],
        correct: 1,
        explanation: 'Decorator Pattern allows behavior to be added to an individual object, dynamically, without affecting the behavior of other objects from the same class. (Structural Pattern)'
    },
    {
        id: 169,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Strategy Pattern?',
        options: [
            'A project management methodology',
            'Defines a family of algorithms, encapsulates each one, and makes them interchangeable',
            'A database indexing strategy',
            'A testing strategy for unit tests'
        ],
        correct: 1,
        explanation: 'Strategy Pattern lets the algorithm vary independently from clients that use it. It enables selecting an algorithm at runtime. (Behavioral Pattern)'
    },
    {
        id: 170,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Facade Pattern?',
        options: [
            'A front-end UI component',
            'Provides a simplified interface to a library, a framework, or any other complex set of classes',
            'An algorithm for face detection',
            'A proxy for network requests'
        ],
        correct: 1,
        explanation: 'Facade Pattern defines a higher-level interface that makes the subsystem easier to use, hiding the complexities of the system. (Structural Pattern)'
    },
    {
        id: 171,
        category: 'Design Patterns',
        difficulty: 'Hard',
        question: 'What is the Proxy Pattern?',
        options: [
            'A network configuration setting',
            'Provides a surrogate or placeholder for another object to control access to it',
            'A VPN tunneling protocol',
            'A firewall rule set'
        ],
        correct: 1,
        explanation: 'Proxy Pattern controls access to the original object, allowing you to perform something either before or after the request gets through to the original object. (Structural Pattern)'
    },
    {
        id: 172,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the **Output** of this code?\n```csharp\nint x = 5;\nConsole.WriteLine(x);\n```',
        options: [
            'A list of console commands',
            'Encapsulates a request as an object, thereby letting you parameterize clients with different requests',
            'Voice recognition command processing',
            'Keyboard shortcuts mapping'
        ],
        correct: 1,
        explanation: 'Command Pattern turns a request into a stand-alone object that contains all information about the request. It supports undo/redo operations. (Behavioral Pattern)'
    },
    {
        id: 173,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Template Method Pattern?',
        options: [
            'HTML email templates',
            'Defines the skeleton of an algorithm in the superclass but lets subclasses override specific steps',
            'Code snippet templates in IDEs',
            'A generic class template'
        ],
        correct: 1,
        explanation: 'Template Method Pattern defines the skeleton of an algorithm in the base class but lets subclasses override specific steps of the algorithm without changing its structure. (Behavioral Pattern)'
    },
    {
        id: 174,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Composite Pattern?',
        options: [
            'Image composition algorithm',
            'Composes objects into tree structures to represent part-whole hierarchies',
            'Video editing software pattern',
            'Mixing colors for UI themes'
        ],
        correct: 1,
        explanation: 'Composite Pattern lets clients treat individual objects and compositions of objects uniformly. Used for tree structures like file systems or UI hierarchies. (Structural Pattern)'
    },
    {
        id: 175,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Iterator Pattern?',
        options: [
            'A simple for-loop structure',
            'Provides a way to access the elements of an aggregate object sequentially without exposing its underlying representation',
            'Recursion optimization',
            'A counter variable'
        ],
        correct: 1,
        explanation: 'Iterator Pattern provides a way to traverse elements of a collection without exposing its internal structure. C# "foreach" uses this pattern (IEnumerable/IEnumerator). (Behavioral Pattern)'
    },
    {
        id: 176,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the State Pattern?',
        options: [
            'Saving application state to disk',
            'Allows an object to alter its behavior when its internal state changes',
            'State management library (like Redux)',
            'Database transaction states'
        ],
        correct: 1,
        explanation: 'State Pattern allows an object to appear as if it changed its class when its internal state changes. It encapsulates state-specific behavior in separate state classes. (Behavioral Pattern)'
    },
    {
        id: 177,
        category: 'Design Patterns',
        difficulty: 'Hard',
        question: 'What is the Mediator Pattern?',
        options: [
            'Conflict resolution strategy',
            'Defines an object that encapsulates how a set of objects interact',
            'A middleman in a transaction',
            'Network router configuration'
        ],
        correct: 1,
        explanation: 'Mediator Pattern reduces chaotic dependencies between objects. It forces objects to communicate via a mediator object, promoting loose coupling. (Behavioral Pattern)'
    },
    {
        id: 178,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Chain of Responsibility Pattern?',
        options: [
            'Corporate management hierarchy',
            'Passes a request along a chain of handlers',
            'A linked list data structure',
            'Blockchain technology implementation'
        ],
        correct: 1,
        explanation: 'Chain of Responsibility passes a request along a chain of handlers. Upon receiving a request, each handler decides either to process it or pass it to the next handler. (Behavioral Pattern)'
    },
    {
        id: 179,
        category: 'Design Patterns',
        difficulty: 'Hard',
        question: 'What is the Visitor Pattern?',
        options: [
            'Tracking website visitors',
            'Separates an algorithm from an object structure on which it operates',
            'Managing guest user access',
            'Authentication pattern for visitors'
        ],
        correct: 1,
        explanation: 'Visitor Pattern lets you define a new operation without changing the classes of the elements on which it operates. Double dispatch is key here. (Behavioral Pattern)'
    },
    {
        id: 180,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Memento Pattern?',
        options: [
            'A souvenir from a trip',
            'Captures and externalizes an object\'s internal state so that it can be restored later',
            'A memory leak detection tool',
            'Caching mechanism'
        ],
        correct: 1,
        explanation: 'Memento Pattern allows you to save and restore the previous state of an object without revealing the details of its implementation. Used for undo mechanisms. (Behavioral Pattern)'
    },
    {
        id: 181,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Flyweight Pattern?',
        options: [
            'A lightweight class hierarchy',
            'Fits more objects into the available amount of RAM by sharing common parts of state',
            'Physics simulation for flying objects',
            'Data compression algorithm'
        ],
        correct: 1,
        explanation: 'Flyweight Pattern minimizes memory usage by sharing as much data as possible with other similar objects. Used when dealing with large numbers of objects. (Structural Pattern)'
    },
    {
        id: 182,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Abstract Factory Pattern?',
        options: [
            'A factory class that is marked abstract',
            'Produces families of related or dependent objects without specifying their concrete classes',
            'Industrial manufacturing process simulation',
            'A pattern for creating abstract classes'
        ],
        correct: 1,
        explanation: 'Abstract Factory provides an interface for creating families of related or dependent objects without specifying their concrete classes. (Creational Pattern)'
    },
    {
        id: 183,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Prototype Pattern?',
        options: [
            'A beta version of software',
            'Creates new objects by copying an existing object',
            'First draft of a document',
            'A model for database schema'
        ],
        correct: 1,
        explanation: 'Prototype Pattern allows copying existing objects without making your code dependent on their classes. It delegates the cloning process to the actual objects. (Creational Pattern)'
    },
    {
        id: 184,
        category: 'Design Patterns',
        difficulty: 'Easy',
        question: 'What is the Service Locator Pattern?',
        options: [
            'A tool for finding services in a city',
            'A registry that provides global access to dependencies',
            'GPS location service',
            'Map navigation algorithm'
        ],
        correct: 1,
        explanation: 'Service Locator is a pattern used to obtain dependencies. However, it is often considered an anti-pattern in modern .NET because it hides class dependencies.'
    },
    {
        id: 185,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'Which pattern is MVVM (Model-View-ViewModel)?',
        options: [
            'Creational Pattern',
            'Architectural Pattern',
            'Structural Pattern',
            'Behavioral Pattern'
        ],
        correct: 1,
        explanation: 'MVVM is an Architectural Pattern used to separate the development of the UI (View) from the business logic and back-end logic (Model), connected by the ViewModel.'
    },
    {
        id: 186,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Null Object Pattern?',
        options: [
            'A null reference exception',
            'An object with defined neutral ("null") behavior',
            'A database null value',
            'A void method return type'
        ],
        correct: 1,
        explanation: 'Null Object Pattern uses an object to represent the absence of a value (instead of null), removing the need for null checks in client code.'
    },
    {
        id: 187,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Bridge Pattern?',
        options: [
            'Connects two physical locations',
            'Splits a large class or a set of closely related classes into two separate hierarchies',
            'Networking bridge device',
            'Data bridge between databases'
        ],
        correct: 1,
        explanation: 'Bridge Pattern splits a large class into two separate hierarchies (Abstraction and Implementation), which can be developed independently. (Structural Pattern)'
    },
    {
        id: 188,
        category: 'Design Patterns',
        difficulty: 'Medium',
        question: 'What is the Builder Pattern best for?',
        options: [
            'Creating simple objects',
            'Constructing complex objects step-by-step',
            'Building software projects',
            'Managing database builds'
        ],
        correct: 1,
        explanation: 'Builder Pattern allows you to construct complex objects step by step. It allows you to produce different types and representations of an object using the same construction code. (Creational Pattern)'
    },

    // New Threading & Async Questions
    {
        id: 189,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is the difference between "Task" and "Thread"?',
        options: [
            'No functional difference',
            'Thread is a lower-level OS concept; Task is a higher-level abstraction managed by the Thread Pool',
            'Task is slower than Thread',
            'Thread is deprecated in .NET'
        ],
        correct: 1,
        explanation: 'A Thread is a low-level execution path managed by the OS. A Task is a higher-level abstraction representing a unit of work, which the Thread Pool schedules onto threads.'
    },
    {
        id: 190,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is "ValueTask<T>"?',
        options: [
            'A value type version of Task<T> to reduce allocation overhead',
            'A task that returns a currency value',
            'A deprecated task type replaced by Task<T>',
            'A slower, thread-safe version of Task'
        ],
        correct: 0,
        explanation: 'ValueTask<T> is a struct-based alternative to Task<T>. It helps reduce memory allocation overhead when the result is often already available synchronously.'
    },
    {
        id: 191,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is the "Interlocked" class used for?',
        options: [
            'Locking files on disk',
            'Performing atomic operations on variables shared by multiple threads',
            'Managing database transactions',
            'Establishing secure network connections'
        ],
        correct: 1,
        explanation: 'Interlocked class provides static methods for atomic operations (Increment, Decrement, Exchange) on variables, which is faster and lighter than full locks.'
    },
    {
        id: 192,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "Task.WhenAll"?',
        options: [
            'Waits for the first task to complete',
            'Creates a task that completes when all supplied tasks have completed',
            'Stops all running tasks immediately',
            'Runs tasks sequentially on a single thread'
        ],
        correct: 1,
        explanation: 'Task.WhenAll creates a task that completes when a set of tasks have all completed. The result contains an array of results from all the tasks.'
    },
    {
        id: 193,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is the difference between "Monitor" and "Mutex"?',
        options: [
            'No functional difference',
            'Monitor is process-local; Mutex can span across processes (system-wide)',
            'Monitor is slower than Mutex',
            'Mutex is deprecated in favor of Monitor'
        ],
        correct: 1,
        explanation: 'Monitor (lock) is lightweight and restricted to the current AppDomain/Process. Mutex is a primitive that can be used for inter-process synchronization.'
    },
    {
        id: 194,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "SemaphoreSlim"?',
        options: [
            'A database record lock',
            'A lightweight alternative to Semaphore that limits the number of threads that can access a resource',
            'A UI thread synchronization context',
            'A networking protocol for handshakes'
        ],
        correct: 1,
        explanation: 'SemaphoreSlim is a lightweight synchronization primitive that limits the number of threads that can access a resource concurrently. It supports async waits.'
    },
    {
        id: 195,
        category: 'Threading & Async',
        difficulty: 'Easy',
        question: 'What is a Race Condition?',
        options: [
            'Fast code execution speed',
            'When program behavior depends on the relative timing of events (threads)',
            'A network speed benchmark test',
            'A database query optimization technique'
        ],
        correct: 1,
        explanation: 'A race condition occurs when two or more threads access shared data and try to change it at the same time, leading to unpredictable results.'
    },
    {
        id: 196,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is "TaskCompletionSource"?',
        options: [
            'A factory for creating Tasks',
            'Enables creating a Task that can be manually controlled (set result, exception, etc.)',
            'A database connection source',
            'A compiler optimization feature'
        ],
        correct: 1,
        explanation: 'TaskCompletionSource<T> allows you to create a Task and manually transition it to Completed, Faulted, or Canceled states. Useful for wrapping non-Task async APIs.'
    },
    {
        id: 197,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "Parallel.ForEach"?',
        options: [
            'A standard foreach loop',
            'A loop that executes iterations in parallel',
            'A LINQ query for filtering lists',
            'A method to sort lists in parallel'
        ],
        correct: 1,
        explanation: 'Parallel.ForEach executes a "foreach" loop in which iterations may run in parallel on multiple threads. It blocks until all work is done.'
    },
    {
        id: 198,
        category: 'Threading & Async',
        difficulty: 'Easy',
        question: 'What is the Thread Pool?',
        options: [
            'A memory allocation pool',
            'A collection of worker threads managed by the runtime',
            'A database connection pool',
            'A list of pending tasks'
        ],
        correct: 1,
        explanation: 'The Thread Pool is a collection of pre-created worker threads that reuse threads for many tasks, avoiding the overhead of creating and destroying threads repeatedly.'
    },
    {
        id: 199,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is "AsyncLocal<T>"?',
        options: [
            'A local variable inside an async method',
            'Stores data that is local to a given asynchronous control flow',
            'A database field for async storage',
            'A global static variable'
        ],
        correct: 1,
        explanation: 'AsyncLocal<T> provides a way to store data that flows with the asynchronous execution context (e.g. across await calls), unlike ThreadLocal which is bound to a specific thread.'
    },
    {
        id: 200,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is the "lock" statement actually syntactic sugar for?',
        options: [
            'Monitor.Enter and Monitor.Exit',
            'Mutex.WaitOne and Mutex.ReleaseMutex',
            'Semaphore.Wait and Semaphore.Release',
            'SpinLock.Enter and SpinLock.Exit'
        ],
        correct: 0,
        explanation: 'The "lock" statement is compiled into a Monitor.Enter call in a try block and a Monitor.Exit call in a finally block.'
    },
    {
        id: 201,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "IAsyncEnumerable"?',
        options: [
            'An asynchronous array type',
            'Interface for asynchronous iteration (Async Streams)',
            'A reference type for streams',
            'A LINQ query provider'
        ],
        correct: 1,
        explanation: 'IAsyncEnumerable<T> (C# 8.0) enables asynchronous streams, allowing you to iterate over a data source where pulling the next element might involve an async operation.'
    },
    {
        id: 202,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is "ReaderWriterLockSlim"?',
        options: [
            'A file system lock',
            'Lock optimized for cases where reads are frequent but writes are rare',
            'A database table lock',
            'A slow, legacy lock type'
        ],
        correct: 1,
        explanation: 'ReaderWriterLockSlim allows multiple threads to read a resource concurrently (shared mode) but requires exclusive access for writing. More efficient than simple locks for read-heavy scenarios.'
    },
    {
        id: 203,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "Channel<T>" used for?',
        options: [
            'Networking protocols',
            'Producer/Consumer scenarios',
            'TV signal processing',
            'File Input/Output operations'
        ],
        correct: 1,
        explanation: 'System.Threading.Channels provides a thread-safe data structure for passing data between producers and consumers asynchronously.'
    },
    {
        id: 204,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What happens if you "await" inside a lock?',
        options: [
            'It is allowed and safe',
            'It is a compile-time error',
            'It causes a deadlock at runtime',
            'It works but degrades performance'
        ],
        correct: 1,
        explanation: 'You cannot use the "await" keyword inside a "lock" statement. It is a compile-time error because the lock implies thread affinity, and await might resume on a different thread.'
    },
    {
        id: 205,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is "SynchronizationContext"?',
        options: [
            'Time synchronization service',
            'Abstraction that handles thread marshaling (e.g., returning to UI thread)',
            'Database transaction context',
            'Cloud data synchronization'
        ],
        correct: 1,
        explanation: 'SynchronizationContext captures the context (like UI thread) so that continuations after an await can resume on the original context. Important in WinForms/WPF/ASP.NET (legacy).'
    },
    {
        id: 206,
        category: 'Threading & Async',
        difficulty: 'Easy',
        question: 'What is "Task.Delay"?',
        options: [
            'Blocks the current thread',
            'Creates a task that completes after a specified time interval (non-blocking)',
            'Sleeps the current thread',
            'Stops the application execution'
        ],
        correct: 1,
        explanation: 'Task.Delay creates a task that completes after a delay. Unlike Thread.Sleep, it does not block the thread; it logically pauses the async method.'
    },
    {
        id: 207,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "AggregateException"?',
        options: [
            'A single standard exception',
            'Exception type used to flatten and contain multiple exceptions (e.g. from Task.WhenAll)',
            'A database connection error',
            'A network timeout error'
        ],
        correct: 1,
        explanation: 'AggregateException is used to consolidate multiple exceptions thrown from parallel or concurrent operations (like Task.WaitAll or PLINQ).'
    },
    {
        id: 208,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "Task.Yield"?',
        options: [
            'Returns a result value',
            'Forces the method to yield execution back to the caller (asynchronously)',
            'Pauses the thread indefinitely',
            'Cancels the current task'
        ],
        correct: 1,
        explanation: 'Task.Yield() creates an awaitable that asynchronously yields back to the current context. It forces the remainder of the method to run asynchronously.'
    },
    {
        id: 209,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is "SpinLock"?',
        options: [
            'A fast lock using busy waiting',
            'A lock that spins the hard drive',
            'A slow, deprecated lock',
            'A recursive lock type'
        ],
        correct: 0,
        explanation: 'SpinLock is a low-level synchronization primitive that spins in a loop (busy wait) checking if the lock is available. Useful for very short wait times, avoiding context switch.'
    },
    {
        id: 210,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "BackgroundService"?',
        options: [
            'A generic standard library class',
            'Base class for implementing long-running IHostedService (Worker Services)',
            'A database background process',
            'A UI background thread'
        ],
        correct: 1,
        explanation: 'BackgroundService is a base class for generic long-running services in .NET Core. You override ExecuteAsync to perform the work.'
    },
    {
        id: 211,
        category: 'Threading & Async',
        difficulty: 'Easy',
        question: 'Does "async void" catch exceptions?',
        options: [
            'Yes, it catches them automatically',
            'No, exceptions in async void methods crash the process',
            'Only IO exceptions are caught',
            'Only on specific days'
        ],
        correct: 1,
        explanation: 'Exceptions thrown in an "async void" method cannot be caught by the caller and will crash the process (unless caught inside the method). Avoid "async void" except for event handlers.'
    },
    {
        id: 212,
        category: 'Threading & Async',
        difficulty: 'Hard',
        question: 'What is Context Switching?',
        options: [
            'Renaming variables',
            'OS saving state of one thread and restoring another',
            'Switching database context',
            'Switching user accounts'
        ],
        correct: 1,
        explanation: 'Context Switching is the process of storing the state of a process or thread so that it can be restored and execution resumed later. It is computationally expensive.'
    },
    {
        id: 213,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is Starvation in threading?',
        options: [
            'Memory leak issue',
            'When a thread is perpetually denied access to resources',
            'Low battery power',
            'Network connection timeout'
        ],
        correct: 1,
        explanation: 'Starvation occurs when a thread is unable to gain regular access to shared resources and is unable to make progress (e.g. lower priority threads never running).'
    },
    {
        id: 214,
        category: 'Threading & Async',
        difficulty: 'Medium',
        question: 'What is "ThreadLocal<T>"?',
        options: [
            'A global variable shared by threads',
            'Provides thread-local storage of data',
            'A method local variable',
            'A task-specific variable'
        ],
        correct: 1,
        explanation: 'ThreadLocal<T> provides storage that is local to a thread. Each thread accesses its own separate instance of the data.'
    },
    {
        id: 215,
        category: 'Threading & Async',
        difficulty: 'Easy',
        question: 'What is the "Volatile" keyword?',
        options: [
            'Marks code as dangerous',
            'Indicates a field might be modified by multiple threads, disabling some compiler optimizations',
            'Optimizes code for speed',
            'Encrypts the variable'
        ],
        correct: 1,
        explanation: 'The volatile keyword indicates that a field might be modified by multiple threads that are executing at the same time. It ensures the most up-to-date value is present in the field at all times.'
    },

    // New Security Questions
    {
        id: 216,
        category: 'Security',
        difficulty: 'Easy',
        question: 'What is XSS (Cross-Site Scripting)?',
        options: [
            'A modern CSS framework for styling',
            'A database injection technique',
            'An attack where malicious scripts are injected into trusted websites',
            'Server-side scripting vulnerability'
        ],
        correct: 2,
        explanation: 'XSS allows attackers to inject malicious scripts into web pages viewed by other users, often extracting cookies or session tokens.'
    },
    {
        id: 217,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What are the three main types of XSS?',
        options: [
            'Reflected, Stored, and DOM-based',
            'Fast, Slow, and Intermediate execution',
            'GET, POST, and DELETE injection',
            'Server, Client, and Database XSS'
        ],
        correct: 0,
        explanation: 'Reflected (in URL parameters), Stored (saved in database/comments), and DOM-based (executed in client-side JS).'
    },
    {
        id: 218,
        category: 'Security',
        difficulty: 'Hard',
        question: 'What is CSP (Content Security Policy)?',
        options: [
            'Customer Service Policy for apps',
            'An HTTP header that allows site operators to restrict the resources (scripts, images) the user agent is allowed to load',
            'Secure password complexity policy',
            'Cloud security protocol'
        ],
        correct: 1,
        explanation: 'CSP is an added layer of security that helps to detect and mitigate certain types of attacks, including XSS and data injection attacks.'
    },
    {
        id: 219,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is the "SameSite" cookie attribute used for?',
        options: [
            'To keep cookies strictly on one server',
            'To prevent CSRF attacks by controlling when cookies are sent with cross-site requests',
            'To automatically delete old cookies',
            'To encrypt cookies for matching sites'
        ],
        correct: 1,
        explanation: 'SameSite=Strict/Lax prevents the browser from sending usage cookies with cross-site requests, mitigating Cross-Site Request Forgery (CSRF).'
    },
    {
        id: 220,
        category: 'Security',
        difficulty: 'Easy',
        question: 'What is "Mass Assignment" (Overposting)?',
        options: [
            'Assigning many variables at once in code',
            'When an attacker modifies properties they shouldn\'t have access to by blindly binding request data to models',
            'A dedicated bulk database update operation',
            'A massive DDoS attack'
        ],
        correct: 1,
        explanation: 'Mass Assignment occurs when input data is automatically bound to object properties without filtering, allowing attackers to modify protected fields (like IsAdmin).'
    },
    {
        id: 221,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is OAuth 2.0?',
        options: [
            'A user authentication protocol',
            'An authorization framework that enables applications to obtain limited access to user accounts',
            'An advanced encryption standard',
            'A secure database format'
        ],
        correct: 1,
        explanation: 'OAuth 2.0 is an authorization framework. It delegates authentication to a service provider (like Google) and grants access tokens to third-party apps.'
    },
    {
        id: 222,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is OpenID Connect (OIDC)?',
        options: [
            'A database connector for open source',
            'An identity layer on top of the OAuth 2.0 protocol',
            'An open source unique ID generator',
            'A secure VPN protocol'
        ],
        correct: 1,
        explanation: 'OIDC sits on top of OAuth 2.0 and adds authentication (identity) handling. It provides an ID Token (JWT) containing information about the user.'
    },
    {
        id: 223,
        category: 'Security',
        difficulty: 'Hard',
        question: 'What is "Clickjacking"?',
        options: [
            'Stealing mouse clicks via software',
            'Tricking a user into clicking on something different from what the user perceives (often using invisible iframes)',
            'Double clicking erroneously',
            'Right clicking to bypass security'
        ],
        correct: 1,
        explanation: 'Clickjacking uses transparent iframes to overlay a legitimate button with a disguised one, tricking users into performing actions without their knowledge. Prevent with X-Frame-Options.'
    },
    {
        id: 224,
        category: 'Security',
        difficulty: 'Easy',
        question: 'Is Base64 encoding a form of encryption?',
        options: [
            'Yes, it is very secure',
            'No, it is just an encoding scheme and can be easily decoded',
            'Only if salted with a key',
            'Yes, specifically for images'
        ],
        correct: 1,
        explanation: 'Base64 is an encoding scheme (binary-to-text), NOT encryption. It creates no security and is easily reversed.'
    },
    {
        id: 225,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is XXE (XML External Entity) attack?',
        options: [
            'Cross-site scripting in XML',
            'An attack against an application that parses XML input allowing access to local files or internal networks',
            'SQL injection via XML',
            'JSON structure attack'
        ],
        correct: 1,
        explanation: 'XXE occurs when XML input containing a reference to an external entity is processed by a weakly configured XML parser, leading to data disclosure.'
    },
    {
        id: 226,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is a "Salt" in password hashing?',
        options: [
            'Making the password string longer',
            'Random data added to the password input before hashing to defend against dictionary/rainbow table attacks',
            'An encryption key for the hash',
            'A "Pepper" value used for reversing the hash'
        ],
        correct: 1,
        explanation: 'A salt is a unique, random string added to each password before hashing. It ensures that the same password hashes to different values for different users.'
    },
    {
        id: 227,
        category: 'Security',
        difficulty: 'Easy',
        question: 'What does the "HttpOnly" flag on a cookie do?',
        options: [
            'Makes cookie HTTP only (no HTTPS support)',
            'Prevents client-side scripts (JavaScript) from accessing the cookie',
            'Speeds up HTTP requests containing cookies',
            'Automatically deletes the cookie after the session'
        ],
        correct: 1,
        explanation: 'HttpOnly prevents XSS attacks from stealing the cookie via document.cookie. The cookie is still sent with requests but is inaccessible to JS.'
    },
    {
        id: 228,
        category: 'Security',
        difficulty: 'Hard',
        question: 'What is "Defense in Depth"?',
        options: [
            'Deep learning for security',
            'Using multiple layers of security controls to protect information',
            'Defending the deep web',
            'Submarine defense strategy'
        ],
        correct: 1,
        explanation: 'Defense in Depth is the practice of layering multiple security measures (firewalls, auth, WAF, encryption) so that if one fails, others provide protection.'
    },
    {
        id: 229,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is Claims-Based Identity?',
        options: [
            'Insurance claims processing',
            'Identity based on a set of claims (key-value pairs) issued by a trusted provider',
            'Login strings stored in a database',
            'Anonymous identity verification'
        ],
        correct: 1,
        explanation: 'Claims-based identity abstracts the individual elements of identity (name, email, role) into "claims" inside a token, decoupling auth logic from user profile structure.'
    },
    {
        id: 230,
        category: 'Security',
        difficulty: 'Easy',
        question: 'What is Parameterized Query?',
        options: [
            'A query that executes slowly',
            'A query where placeholders are used instead of direct string concatenation, preventing SQL Injection',
            'A complex stored procedure',
            'A search query with multiple parameters'
        ],
        correct: 1,
        explanation: 'Parameterized queries ensure that inputs are treated as data, not executable code. This is the primary defense against SQL Injection.'
    },
    {
        id: 231,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is User Secrets in .NET Core?',
        options: [
            'Secret list of users',
            'A tool to store sensitive data (like connection strings) outside the project tree during development',
            'Hidden system files',
            'Encrypted source code'
        ],
        correct: 1,
        explanation: 'User Secrets allow developers to store secrets in a JSON file in the user profile directory, keeping them out of source control (git).'
    },
    {
        id: 232,
        category: 'Security',
        difficulty: 'Hard',
        question: 'What information is contained in the "aud" (Audience) claim of a JWT?',
        options: [
            'Audio data embedded in token',
            'The recipient(s) that the JWT is intended for',
            'The issuer of the token',
            'The user identification'
        ],
        correct: 1,
        explanation: '"aud" identifies the recipients that the JWT is intended for. The recipient must verify that the "aud" matches its own identifier.'
    },
    {
        id: 233,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is "OWASP Top 10"?',
        options: [
            'Top 10 programmers list',
            'A standard awareness document representing the most critical security risks to web applications',
            'Top 10 most visited websites',
            'Security software comparison'
        ],
        correct: 1,
        explanation: 'OWASP Top 10 lists the most critical web application security risks, such as Injection, Broken Authentication, and Sensitive Data Exposure.'
    },
    {
        id: 234,
        category: 'Security',
        difficulty: 'Easy',
        question: 'What is TLS?',
        options: [
            'Text Layer Security protocol',
            'Transport Layer Security - cryptographic protocol designed to provide communications security over a computer network',
            'Top Level Security clearance',
            'Total Lock System for databases'
        ],
        correct: 1,
        explanation: 'TLS is the successor to SSL. It encrypts data sent over the Internet to ensure widespread privacy and data integrity (HTTPS).'
    },
    {
        id: 235,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is the "Secure" flag on a cookie?',
        options: [
            'Encrypts the cookie name',
            'Ensures the cookie is only sent over encrypted (HTTPS) connections',
            'Locks the cookie against changes',
            'Hides the cookie from the browser'
        ],
        correct: 1,
        explanation: 'The Secure flag prevents the cookie from being sent over unencrypted HTTP connections, reducing the risk of interception.'
    },
    {
        id: 236,
        category: 'Security',
        difficulty: 'Hard',
        question: 'What is CORS (Cross-Origin Resource Sharing) configuration vulnerability?',
        options: [
            'Having too many origins',
            'Allowing arbitrary origins (Access-Control-Allow-Origin: *) with credentials enabled',
            'Slow resource sharing',
            'Disabling sharing completely'
        ],
        correct: 1,
        explanation: 'Misconfigured CORS (like reflecting the Origin header or using "null" origin) can allow attackers to perform privileged actions on behalf of the user.'
    },
    {
        id: 237,
        category: 'Security',
        difficulty: 'Medium',
        question: 'What is Rate Limiting?',
        options: [
            'Measuring download speed',
            'Restricting the number of requests a user can make in a given timeframe to prevent abuse/DoS',
            'Limiting database size',
            'Limiting number of active users'
        ],
        correct: 1,
        explanation: 'Rate Limiting controls the rate of traffic sent or received. It prevents DoS attacks and brute-force attempts.'
    },
    {
        id: 238,
        category: 'Security',
        difficulty: 'Easy',
        question: 'Why avoid using MD5 for password hashing?',
        options: [
            'It is too slow for modern systems',
            'It is cryptographically broken and prone to collision attacks',
            'It takes too much memory',
            'It is a proprietary algorithm'
        ],
        correct: 1,
        explanation: 'MD5 is fast and has collision vulnerabilities, making it easy to crack with rainbow tables or brute force. Use bcrypt, Argon2, or PBKDF2 instead.'
    },
    {
        id: 239,
        category: 'Security',
        difficulty: 'Hard',
        question: 'What is DPAPI (Data Protection API)?',
        options: [
            'Standard Database API',
            'A cryptographic API in Windows/.NET for symmetrical encryption of data using user or machine credentials',
            'Public API for data access',
            'Data parser for XML'
        ],
        correct: 1,
        explanation: 'DPAPI provides services for valid protection of data. It uses the user\'s or machine\'s login credentials to encrypt data without explicit key management.'
    },

    // New Performance Questions
    {
        id: 240,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is StructLayoutArea and why does it matter?',
        options: [
            'Organizes UI component layout',
            'Attributes like [StructLayout(LayoutKind.Sequential)] control how fields are laid out in memory, affecting interop and cache locality',
            'Database table layout optimization',
            'File system layout'
        ],
        correct: 1,
        explanation: 'StructLayout controls the memory layout of a class or struct. Optimizing layout (e.g. padding, packing) can improve CPU cache utilization and performance.'
    },
    {
        id: 241,
        category: 'Performance',
        difficulty: 'Easy',
        question: 'Why avoid throwing exceptions for normal control flow?',
        options: [
            'Exceptions are slow to catch and unwind the stack',
            'Exceptions are confusing to read',
            'Exceptions consume excessive disk space',
            'Exceptions cannot be logged properly'
        ],
        correct: 0,
        explanation: 'Throwing and catching exceptions is computationally expensive (stack unwinding). Using logic (if/else) for expected conditions is much faster.'
    },
    {
        id: 242,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is "String Interning"?',
        options: [
            'Hiring interns to write string code',
            'Storing only one copy of each unique string literal in a pool to save memory',
            'String compression algorithm',
            'String encryption for security'
        ],
        correct: 1,
        explanation: 'String Interning stores unique strings in a pool. If the same string literal is used again, the reference to the existing instance is returned, saving memory.'
    },
    {
        id: 243,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is the "Large Object Heap" (LOH)?',
        options: [
            'Heap for large databases',
            'A heap segment for objects larger than 85,000 bytes, which is collected less frequently',
            'A heap reserved for static variables',
            'A specialized heap for long strings'
        ],
        correct: 1,
        explanation: 'Objects >= 85KB go to the LOH. The LOH is compacted less frequently (mostly during Gen 2 GCs) to avoid performance penalties, but this can lead to fragmentation.'
    },
    {
        id: 244,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is "Span<T>"?',
        options: [
            'A UI element spanning multiple columns',
            'A stack-only type that provides a type-safe, memory-safe representation of a contiguous region of arbitrary memory',
            'A database span for transactions',
            'A threading tool for spanning tasks'
        ],
        correct: 1,
        explanation: 'Span<T> enables working with contiguous memory (arrays, strings, native memory) without allocation or copying, significantly improving performance in high-throughput scenarios.'
    },
    {
        id: 245,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is "ArrayPool<T>"?',
        options: [
            'A data structure for swimming pool management',
            'A shared pool of arrays to reduce allocation overhead of frequent temporary buffers',
            'A linked list of arrays',
            'A database connection pool'
        ],
        correct: 1,
        explanation: 'ArrayPool<T> allows renting and returning buffers. This drastically reduces garbage collection pressure by reusing arrays instead of allocating new ones.'
    },
    {
        id: 246,
        category: 'Performance',
        difficulty: 'Easy',
        question: 'Why is "Boxing" considered expensive?',
        options: [
            'It requires extra storage code',
            'It allocates a new object on the heap and copies the value, adding GC pressure',
            'It is hard to read and understand',
            'It is a deprecated feature'
        ],
        correct: 1,
        explanation: 'Boxing converts a value type to an object, forcing a heap allocation and copy. Frequent boxing creates garbage and slows down the application.'
    },
    {
        id: 247,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is "SIMD" (Single Instruction, Multiple Data)?',
        options: [
            'Simple Instruction Machine Data',
            'Hardware capability to perform the same operation on multiple data points simultaneously (Vectorization)',
            'Standard Interface for Multiple Databases',
            'Single Input Multiple Device protocol'
        ],
        correct: 1,
        explanation: 'SIMD allows the CPU to process multiple values with a single instruction. .NET provides System.Numerics.Vectors to utilize these hardware intrinsics.'
    },
    {
        id: 248,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is the impact of "Finalizers" (Destructors) on GC?',
        options: [
            'Speeds up Garbage Collection',
            'Delays reclamation of memory because objects must be put on the finalizer queue first',
            'No significant impact',
            'Frees memory instantly upon destruction'
        ],
        correct: 1,
        explanation: 'Objects with finalizers survive the first GC collection they are found in, moving to the Finalizer Queue. They require at least two GC cycles to be fully collected.'
    },
    {
        id: 249,
        category: 'Performance',
        difficulty: 'Easy',
        question: 'What is "Lazy<T>"?',
        options: [
            'A placeholder for lazy developers',
            'Provides support for lazy initialization (deferring creation until used)',
            'A slow performance variable',
            'A database delay mechanism'
        ],
        correct: 1,
        explanation: 'Lazy<T> defers the instantiation of a resource-intensive object until it is accessed for the first time, saving startup time and memory.'
    },
    {
        id: 250,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is the difference between "Release" and "Debug" build configurations?',
        options: [
            'No functional difference',
            'Release enables optimizations (inlining, removing dead code) and disables debug symbols overhead',
            'Debug is faster for execution',
            'Release is solely for testing purposes'
        ],
        correct: 1,
        explanation: 'Release builds enables the JIT compiler to perform aggressive optimizations. You should always benchmark and deploy usage Release builds.'
    },
    {
        id: 251,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is Tiered Compilation?',
        options: [
            'Programming in multiple tiers',
            'JIT feature that compiles code quickly first (Tier 0), then re-compiles frequently used methods with high optimization (Tier 1)',
            'Database tiered storage',
            'UI component tiers'
        ],
        correct: 1,
        explanation: 'Tiered Compilation balances startup speed and throughput. It starts with a fast, low-quality JIT compilation, and promotes hot methods to high-quality code in the background.'
    },
    {
        id: 252,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is "Memory<T>"?',
        options: [
            'Standard RAM access',
            'Like Span<T> but can be stored on the heap (e.g. in async methods)',
            'Hard drive storage access',
            'L1 Cache access'
        ],
        correct: 1,
        explanation: 'Memory<T> supplements Span<T>. Unlike Span (which is stack-only and cannot be used in async methods), Memory<T> can be stored on the heap.'
    },
    {
        id: 253,
        category: 'Performance',
        difficulty: 'Easy',
        question: 'Why use "async" for I/O bound operations?',
        options: [
            'It looks modern and cool',
            'It frees up the thread to do other work while waiting for I/O, improving scalability',
            'It makes the disk spin faster',
            'It encrypts data automatically'
        ],
        correct: 1,
        explanation: 'Async I/O releases the thread back to the thread pool while waiting for the hardware (disk/network), allowing the server to handle more concurrent requests.'
    },
    {
        id: 254,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is the "stackalloc" keyword?',
        options: [
            'Allocates memory on the stack instead of the heap',
            'Allocates on stack overflow exceptions',
            'Allocates on the heap',
            'Allocates on the hard disk'
        ],
        correct: 0,
        explanation: 'stackalloc allocates a block of memory on the stack. This is very fast and requires no garbage collection, but is cleaned up when method returns.'
    },
    {
        id: 255,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is False Sharing?',
        options: [
            'Lying about resource sharing',
            'Performance degradation when multiple threads modify independent variables that reside on the same cache line',
            'Network bandwidth sharing',
            'Database connection sharing'
        ],
        correct: 1,
        explanation: 'False Sharing occurs when CPUs invalidate each other\'s internal caches because they are writing to variables that coincidentally share the same cache line.'
    },
    {
        id: 256,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is "GCSettings.LatencyMode"?',
        options: [
            'Sets internet network latency',
            'Configures the intrusiveness of the Garbage Collector',
            'Sets hard disk latency',
            'Sets UI rendering latency'
        ],
        correct: 1,
        explanation: 'GCSettings.LatencyMode allows you to tune GC (e.g. SustainedLowLatency) to minimize pauses during critical operations, at the risk of higher memory usage.'
    },
    {
        id: 257,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'Why prefer "List<T>.Capacity" setting?',
        options: [
            'It strictly limits list size',
            'Pre-allocating internal array prevents resizing overhead when adding elements',
            'It automatically sorts the list',
            'It clears the list automatically'
        ],
        correct: 1,
        explanation: 'If you know the size, setting Capacity avoids the need for the List to repeatedly allocate new, larger arrays and copy elements as it grows.'
    },
    {
        id: 258,
        category: 'Performance',
        difficulty: 'Easy',
        question: 'What is the "readonly" keyword benefit for structs?',
        options: [
            'Makes them immutable at runtime',
            'Allows compiler optimization (avoids defensive copies)',
            'Makes them occupy more memory',
            'Makes them static globally'
        ],
        correct: 1,
        explanation: 'Marking a struct (or its members) as readonly tells the compiler it won\'t change, allowing it to pass by reference (in) without creating defensive copies.'
    },
    {
        id: 259,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is PGO (Profile-Guided Optimization)?',
        options: [
            'Performance Graph Optimization',
            'Compiler optimization technique that uses data from previous executions to optimize the current compilation',
            'Database Profile Optimization',
            'Memory Profile Optimization'
        ],
        correct: 1,
        explanation: 'Dynamic PGO (in .NET 6+) allows the JIT to recompile methods based on actual runtime behavior (e.g., branch prediction, virtual call devirtualization) for max speed.'
    },
    {
        id: 260,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is "loop unrolling"?',
        options: [
            'Breaking a loop',
            'Optimization where the compiler (or dev) repeats the loop body to decrease loop control overhead',
            'Deleting a loop entirely',
            'Creating an infinite loop'
        ],
        correct: 1,
        explanation: 'Loop unrolling reduces the frequency of branch instructions and loop maintenance code (increment/compare) by executing the body multiple times per iteration.'
    },
    {
        id: 261,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is the cost of "Reflection"?',
        options: [
            'It is computationally free',
            'High performance cost due to metadata inspection and lack of compiler optimizations',
            'Medium performance cost',
            'Low performance cost'
        ],
        correct: 1,
        explanation: 'Reflection is slow because it involves runtime type inspection, string matching, and bypasses JIT optimizations. Use source generators or delegates if possible.'
    },
    {
        id: 262,
        category: 'Performance',
        difficulty: 'Easy',
        question: 'Why use "yield return"?',
        options: [
            'To pause thread execution',
            'To create an iterator that produces values one by one (deferred execution) without allocating a full collection in memory',
            'To stop method execution',
            'To return null'
        ],
        correct: 1,
        explanation: 'yield return allows stateful iteration. It avoids creating a temporary list content to hold all results, saving memory and allowing processing to start immediately.'
    },
    {
        id: 263,
        category: 'Performance',
        difficulty: 'Hard',
        question: 'What is "Vector<T>"?',
        options: [
            'A dynamic list',
            'A generic SIMD vector type',
            'A database vector field',
            'A 3D geometry point'
        ],
        correct: 1,
        explanation: 'Vector<T> is a cross-platform SIMD type that adapts to the size of the hardware vector registers, allowing portable high-performance vectorized code.'
    },
    {
        id: 264,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is the "frozen" heap (Non-GC Heap) in .NET 8?',
        options: [
            'Cold storage for data',
            'A region for immutable objects (like string literals) that are never garbage collected',
            'Frozen UI thread',
            'Memory dump file'
        ],
        correct: 1,
        explanation: 'The Non-GC Layout (Pinned Object Heap / Frozen Heap) allows runtime to allocate immutable objects that never need to be swept or compacted, reducing GC work.'
    },
    {
        id: 265,
        category: 'Performance',
        difficulty: 'Medium',
        question: 'What is the downside of using "dynamic" keyword?',
        options: [
            'It is too fast for debugging',
            'Runtime overhead of binding, caching, and lack of compile-time safety',
            'It requires more typing',
            'It is a deprecated feature'
        ],
        correct: 1,
        explanation: 'The dynamic keyword forces the DLR (Dynamic Language Runtime) to evaluate operations at runtime, which is significantly slower than statically typed operations.'
    }
];
